<template>
  <div class="profileBuilder">
    <div v-if="LoadingSkeleton" class="profileHeader">
      <div class="headerContainer">
        <div class="containerHeader">
          <div class="headerDetails">
            <div class="deatislTitle">
              <Skeletor class="skeleton-box titleSk" />
            </div>
            <div class="detailsBrand">
              <Skeletor class="skeleton-box brandSk" />
            </div>
            <div class="detailsRole">
              <Skeletor class="skeleton-box roleSk" />
            </div>
          </div>
          <div class="headerProfile">
            <div class="profilePic noStory">
              <Skeletor class="skeleton-box profileSk" />
            </div>
          </div>
        </div>
        <div class="containerMain">
          <div class="mainStatistics">
            <div class="statisticsWrapper">
              <div class="statisticsThumb">
                <Skeletor class="skeleton-box thumbSk" />
              </div>
              <div class="statisticsThumb">
                <Skeletor class="skeleton-box thumbSk" />
              </div>
              <div class="statisticsThumb">
                <Skeletor class="skeleton-box thumbSk" />
              </div>
            </div>
          </div>
          <div class="mainOptions">
            <Skeletor class="skeleton-box thumbSk" />
            <Skeletor class="skeleton-box thumbSk" />
          </div>
        </div>
        <div class="containerFooter">
          <Skeletor v-for="i in 5" :key="i" class="skeleton-box footerSk" />
        </div>
      </div>
    </div>
    <div v-if="info_list && !LoadingSkeleton" class="profileHeader">
      <div class="headerContainer">
        <div class="containerHeader">
          <div class="headerDetails">
            <div class="deatislTitle">
              <span>{{ info_list?.nickname }}</span>
            </div>
            <div class="detailsBrand">شرکت: {{ info_list?.company_name }}</div>
            <div class="detailsRole">
              {{ info_list?.role_fn }}
            </div>
            <div class="detailsRate">
              <div>
                امتیاز <span>{{ info_list?.user_rate }}</span>
              </div>
              <el-rate
                v-if="info_list  && info_list.user_rate != null"
                v-model="info_list.user_rate"
                disabled
              />
            </div>
          </div>
          <div class="headerProfile">
            <div class="profilePic noStory">
              <img :src="info_list?.avatar" alt="profile_picture" />
            </div>
          </div>
        </div>
        <div class="containerMain">
          <div class="mainStatistics">
            <div class="statisticsWrapper">
              <div class="statisticsThumb">
                <div
                  class="thumbValue"
                  v-if="
                    info_list && info_list.posts && info_list.posts.length == 0
                  "
                >
                  0
                </div>
                <div class="thumbValue" v-else>
                  {{ info_list?.posts?.total }}
                </div>
                <div class="thumbTitle">
                  {{ postType == "portfolio" ? "پروژه" : "آگهی" }}
                </div>
              </div>
              <div
                class="statisticsThumb"
                @click="selectedFollowHandler('follower', true)"
              >
                <div class="thumbValue">
                  {{ info_list.length ?? info_list.follower }}
                </div>
                <div class="thumbTitle">دنبال کنندگان</div>
              </div>
              <div
                class="statisticsThumb"
                @click="selectedFollowHandler('following', true)"
              >
                <div class="thumbValue">
                  {{ info_list.length ?? info_list.following }}
                </div>
                <div class="thumbTitle">دنبال شوندگان</div>
              </div>
            </div>
          </div>
          <div
            class="mainOptions"
            :class="{
              userCustomer:
                $store.state.auth.loggedIn &&
                $route.query.uid == $store.state.auth.uid,
            }"
          >
            <div
              class="optionsThumb followBtn"
              v-if="
                ($store.state.auth.uid == null ||
                  $store.state.auth.uid != info_list.uid) &&
                info_list &&
                info_list.is_follow == 1 &&
                !loadingFollow
              "
              @click="follow(info_list.uid)"
            >
              <span>دنبال کردن</span>
              <i class="fas fa-user-plus"></i>
            </div>
            <div
              class="optionsThumb unfollowBtn"
              v-if="
                ($store.state.auth.uid == null ||
                  $store.state.auth.uid != info_list.uid) &&
                info_list &&
                info_list.is_follow == 2 &&
                !loadingFollow
              "
              @click="follow(info_list.uid)"
            >
              <span>لغو دنبال کردن</span>
              <i class="fa-solid fa-user-minus"></i>
            </div>
            <div
              class="optionsThumb followBtn"
              v-if="
                ($store.state.auth.uid == null ||
                  $store.state.auth.uid != info_list.uid) &&
                info_list &&
                info_list.is_follow == 1 &&
                loadingFollow
              "
            >
              <span class="followLoader"></span>
            </div>
            <div
              class="optionsThumb unfollowBtn"
              v-if="
                ($store.state.auth.uid == null ||
                  $store.state.auth.uid != info_list.uid) &&
                info_list &&
                info_list.is_follow == 2 &&
                loadingFollow
              "
            >
              <span class="followLoader"></span>
            </div>
            <div
              class="optionsThumb rateThumb"
              v-if="
                ($store.state.auth.uid == null ||
                  $store.state.auth.uid != $route.query.uid ||
                  ($store.state.auth.uid == $route.query.uid &&
                    userInforamtion &&
                    userInforamtion.role !== 'customer')) &&
                info_list.role != 'customer'
              "
              @click="OpenMessage"
            >
              <span>مشاهده نظرات</span>
              <span class="commentCount">{{
                info_list.user_comments_count
              }}</span>
            </div>
          </div>
        </div>
        <div class="containerFooter">
          <div class="footerSection bioSection">
            <div class="sectionMain" v-html="info_list?.description"></div>
          </div>
          <div
            v-if="
              info_list &&
              info_list.b_activity_type_fa &&
              info_list.b_activity_type_fa.length > 0
            "
            class="footerSection exprtiseSection"
          >
            <div class="sectionHeader">نوع فعالیت</div>
            <div class="sectionMain">
              <div
                class="exprtiseThumb"
                v-for="(v, i) in info_list.b_activity_type_fa"
                :key="i"
              >
                {{ v }}
              </div>
            </div>
          </div>
          <div class="footerSection contactSection">
            <div class="sectionHeader">اطلاعات تماس</div>
            <div class="sectionMain">
              <div v-if="info_list && info_list.address" class="contactThumb">
                <i class="fas fa-map-marker-alt"></i>
                <span>
                  {{ info_list?.address }}
                </span>
              </div>
              <a
                :href="`tel:${info_list?.mobile}`"
                class="contactThumb userMobile"
              >
                <i class="fas fa-phone"></i>
                <span>{{ info_list?.mobile }}</span>
              </a>
              <a
                :href="`tel:${info_list?.phone}`"
                v-if="info_list.phone"
                class="contactThumb userMobile"
              >
                <i class="fa-solid fa-phone-volume"></i>
                <span>{{ info_list?.phone }}</span>
              </a>
            </div>
          </div>
          <div
            v-if="
              info_list &&
              (info_list.telegram || info_list.instagram || info_list.whatsup)
            "
            class="footerSection mediaSection"
          >
            <div class="sectionHeader">شبکه‌های اجتماعی</div>
            <div class="sectionMain">
              <a
                :href="info_list?.telegram"
                v-if="info_list.telegram"
                class="mediaThumb telegram"
              >
                <i class="fa-brands fa-telegram"></i>
              </a>
              <a
                :href="info_list?.instagram"
                v-if="info_list.instagram"
                class="mediaThumb instagram"
              >
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a
                :href="info_list?.whatsup"
                v-if="info_list.whatsup"
                class="mediaThumb whatsapp"
              >
                <i class="fa-brands fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profileBuilderMain">
      <div class="mainHeader">
        <div class="headerWrapper">
          <div
            class="wrapperThumb"
            :class="{ active: postType == 'portfolio' }"
            @click="postTypeHanlder('portfolio')"
          >
            <span>پروژه ها</span>
          </div>
          <div
            class="wrapperThumb"
            :class="{ active: postType == 'post' }"
            @click="postTypeHanlder('post')"
          >
            <span>آگهی ها</span>
          </div>
        </div>
      </div>
      <div class="mainContainer">
        <div
          v-if="
            !LoadingSkeleton &&
            !filterLoading &&
            post_list.length > 0 &&
            postType == 'portfolio'
          "
          class="containerList"
        >
          <div
            class="listThumb"
            v-for="(v, i) in post_list"
            :key="i"
            @click="profileDetailsOpenHandler(v, i)"
          >
            <div class="thumbPic">
              <img :src="v.avatar" alt="" />
            </div>
            <div class="thumbContent">
              <div class="contentTitleWrapper">
                <div class="contentTitle">
                  {{ v.content }}
                </div>
                <div class="contentStatus">
                  {{ v.status_fn }}
                </div>
              </div>
              <div class="contentDesc">
                {{ v.details }}
              </div>
              <div class="contentDetails">
                <div class="detailsRate">
                  <div class="rateThumb">
                    <i class="fas fa-heart"></i>
                    <span>{{ v.likes }}</span>
                  </div>
                  <div class="rateThumb">
                    <i class="fas fa-comment"></i>
                    <span>{{ v.comments_count }}</span>
                  </div>
                </div>
                <div class="detailsDate">
                  <div class="dateThumb">
                    {{ v.created_fa }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="propertyListsContainer"
          v-if="
            !filterLoading &&
            !LoadingSkeleton &&
            post_list.length > 0 &&
            postType == 'post'
          "
        >
          <div
            class="propertyThumb"
            v-for="(v, i) in post_list"
            @click="showPost(v, i)"
            :key="i"
          >
            <div class="propertyPic" @click.stop>
              <div
                class="propertyEditsButtons"
                v-if="
                  $store.state.auth.uid != null &&
                  $store.state.auth.uid == $router.currentRoute._value.query.uid
                "
              >
                <div
                  class="propertyBtn editBtn"
                  @click="editFileOpenHandler(v.id)"
                >
                  <i class="fas fa-edit"></i>
                </div>
                <div class="propertyBtn deleteBtn" @click="del_file(v.id)">
                  <i class="fas fa-trash"></i>
                </div>
              </div>
              <img :src="v.avatar" :alt="v.content" />
            </div>
            <div class="propertyContent">
              <div class="contanteHeader">
                <div class="propertyCategory">
                  {{ v.main_category }}
                  <span v-if="v.main_category_en == 'request'">{{
                    v.request_type
                  }}</span>
                  - {{ v.category }}
                </div>
                <div class="propertyUpload">
                  <div class="propertyUploadIcon">
                    <VsxIcon
                      iconName="Calendar"
                      :size="14"
                      color="#0096c7"
                      type="linear"
                    />
                  </div>
                  <div class="propertyUploadTitle">{{ v.created_fa }}</div>
                </div>
              </div>
              <div class="contentMain">
                <div class="propertyTitle">
                  {{
                    v.content.length > 34
                      ? v.content.slice(0, 34) + "..."
                      : v.content
                  }}
                </div>
                <div class="propertyLocation">
                  <div class="locationIcon">
                    <i class="fa-solid fa-location-dot"></i>
                  </div>
                  <div class="locationTitle" v-if="v.address">
                    {{
                      v.address.length > 44
                        ? v.address.slice(0, 44) + "..."
                        : v.address
                    }}
                  </div>
                </div>

                <div class="contentFeaturesWrapper">
                  <div
                    v-if="v.feature && v.feature.includes('fast')"
                    class="featuresThumb fast"
                  >
                    <i class="fa-solid fa-bolt"></i>
                    <span>فوری</span>
                  </div>
                  <div
                    v-if="v.feature && v.feature.includes('exchangeable')"
                    class="featuresThumb exchange"
                  >
                    <i class="fa-solid fa-rotate"></i>
                    <span>قابل معاوضه</span>
                  </div>
                  <div
                    v-if="
                      v.feature &&
                      (v.feature.includes('single') ||
                        v.feature.includes('student'))
                    "
                    class="featuresThumb single"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="size-6"
                    >
                      <path
                        d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                      />
                      <path
                        d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                      />
                      <path
                        d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                      />
                    </svg>
                    <span>دانشجو/مجرد</span>
                  </div>
                </div>
                <div class="contentPriceWrapper">
                  <div
                    class="priceWrapper"
                    v-if="
                      v.main_category_en != 'rent' &&
                      !(
                        v.main_category_en == 'request' &&
                        v.request_type_en == 'rent'
                      )
                    "
                  >
                    <div
                      class="pricecTitle"
                      v-if="v.main_category_en == 'trade'"
                    >
                      قیمت فروش:
                    </div>
                    <div
                      class="pricecTitle"
                      v-if="v.main_category_en == 'request'"
                    >
                      قیمت خرید:
                    </div>
                    <div
                      v-if="v.main_category_en != 'request'"
                      class="priceValue"
                    >
                      {{ v.total_price }}
                    </div>
                    <div
                      v-if="v.main_category_en == 'request'"
                      class="priceValue"
                    >
                      {{ v.total_price }} تا {{ v.total_price_max }}
                    </div>
                  </div>
                  <div
                    class="priceWrapper"
                    v-if="
                      v.main_category_en == 'rent' ||
                      (v.main_category_en == 'request' &&
                        v.request_type_en == 'rent')
                    "
                  >
                    <div class="pricecTitle">مبلغ رهن:</div>
                    <div
                      v-if="v.main_category_en != 'request'"
                      class="priceValue"
                    >
                      {{ v.mortgage_price }}
                    </div>
                    <div
                      v-if="v.main_category_en == 'request'"
                      class="priceValue"
                    >
                      {{ v.mortgage_price }} تا {{ v.mortgage_price_max }}
                    </div>
                  </div>
                  <div
                    class="priceWrapper"
                    v-if="
                      v.main_category_en == 'rent' ||
                      (v.main_category_en == 'request' &&
                        v.request_type_en == 'rent')
                    "
                  >
                    <div class="pricecTitle">مبلغ اجاره:</div>
                    <div
                      v-if="v.main_category_en != 'request'"
                      class="priceValue"
                    >
                      {{ v.rent_price }}
                    </div>
                    <div
                      v-if="v.main_category_en == 'request'"
                      class="priceValue"
                    >
                      {{ v.rent_price }} تا {{ v.rent_price_max }}
                    </div>
                  </div>
                </div>
                <div class="realStateInfoWrapper">
                  <div class="realStateInfo">
                    <div class="infoPic">
                      <img :src="v.branch_avatar" alt="" />
                    </div>
                    <div v-if="v.branch_title != '-'" class="infoTitle">
                      {{ v.branch_title }}
                    </div>
                    <div v-else class="infoTitle">{{ v.nickname }}</div>
                  </div>
                  <div class="realStateBtn">
                    <div class="followBtn">
                      <div class="followBtnTitle">جزئیات</div>
                      <div class="followBtnIcon">
                        <i class="fas fa-arrow-left"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="loadeMoreLoader" v-if="loadmore_loading">
            <span class="custom-loader"></span>
          </div>
        </div>
        <div v-if="LoadingSkeleton || filterLoading" class="containerList">
          <Skeletor
            v-for="i in 16"
            :key="i"
            class="user-links userlinkSkeletor"
            style="
              width: 100%;
              border-radius: 4px;
              margin-bottom: 0 !important;
              margin-top: 0 !important;
              aspect-ratio: 370/300 !important;
              height: auto !important;
              background: rgb(163, 219, 213);
            "
          />
        </div>
        <div
          v-if="!LoadingSkeleton && post_list.length == 0"
          class="noResultThumb"
        >
          <div class="noResultPic">
            <img :src="publicPath + 'img/notfound.png'" alt="Alt text" />
          </div>
          <div v-if="postType == 'portfolio'" class="noResult">
            پروژه‌ای یافت نشد!
          </div>
          <div v-else class="noResult">هیچ آگهی‌ یافت نشد!</div>
        </div>
        <div class="loadeMoreLoader" v-if="loadmore_loading">
          <span class="custom-loader"></span>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="showDetails"
      align-center
      modal-class="profileDetails"
      :show-close="false"
      @close="profileDetailsCloseHandler"
    >
      <div class="changePostBtn PrevBtn" @click.stop="postIndexDecrease">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m8.25 4.5 7.5 7.5-7.5 7.5"
          />
        </svg>
      </div>
      <div class="changePostBtn NextBtn" @click.stop="postIndexIncrease">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>
      </div>
      <div class="detailsContainer">
        <div class="containerList">
          <div class="listThumb">
            <div class="thumbPic">
              <!-- <img :src="post_list?.[postIndex]?.avatar" alt="" /> -->
              <Swiper
                ref="postSwiper"
                :slides-per-view="1"
                :space-between="16"
                :modules="module"
                :pagination="{
                  dynamicBullets: true,
                }"
                :navigation="true"
                @swiper="onSwiperInitialized"
              >
                <SwiperSlide>
                  <img :src="post_list?.[postIndex]?.avatar" alt="" />
                </SwiperSlide>
                <SwiperSlide
                  v-for="(v, i) in post_list[postIndex]?.photo_galleries_mobile"
                  :key="i"
                >
                  <img :src="v.url" alt="" />
                </SwiperSlide>
                <SwiperSlide
                  v-show="
                    post_list &&
                    post_list[postIndex] &&
                    post_list[postIndex].lat &&
                    post_list[postIndex].lng
                  "
                >
                  <div id="map" class="map"></div>
                </SwiperSlide>
              </Swiper>
            </div>
            <div class="thumbContent">
              <div class="contentHeader">
                <div class="headerContent">
                  <div class="contentPic">
                    <img :src="info_list?.avatar" alt="" />
                  </div>
                  <div class="contentInfo">{{ info_list?.nickname }}</div>
                </div>
                <div class="headerOptions">
                  <div
                    v-if="
                      ($store.state.auth.uid == null ||
                        $store.state.auth.uid != info_list.uid) &&
                      info_list.is_follow == 1
                    "
                    class="optionFollow"
                    @click="follow(info_list.uid)"
                  >
                    دنبال کردن
                  </div>
                  <div
                    class="optionUnFollow"
                    v-if="
                      ($store.state.auth.uid == null ||
                        $store.state.auth.uid != info_list.uid) &&
                      info_list.is_follow == 2
                    "
                    @click="follow(info_list.uid)"
                  >
                    لغو دنبال کردن
                  </div>
                  <div
                    v-if="
                      $store.state.auth.loggedIn &&
                      $store.state.auth.uid == info_list.uid
                    "
                    @click="editPostHandler(post_list?.[postIndex]?.id)"
                    class="optionEditBtn"
                  >
                    <i class="fas fa-edit"></i>
                  </div>
                  <div
                    v-if="
                      $store.state.auth.loggedIn &&
                      $store.state.auth.uid == info_list.uid
                    "
                    @click="del_post(post_list?.[postIndex]?.id)"
                    class="optionDelete"
                  >
                    <i class="fas fa-trash"></i>
                  </div>
                </div>
              </div>
              <div ref="contentMain" class="contentMain">
                <div class="mianHeader">
                  <div class="headerStatus">
                    {{ post_list?.[postIndex]?.status_fn }}
                  </div>
                  <div class="headerTitle">
                    {{ post_list?.[postIndex]?.content }}
                  </div>
                  <div
                    class="headerContent"
                    v-html="formattedDetails(post_list?.[postIndex]?.details)"
                  ></div>
                </div>
                <div class="mainOptions">
                  <div class="optionsList">
                    <div
                      @click="save_like(post_list?.[postIndex]?.id)"
                      class="optionThumb"
                      :class="{ liked: post_list?.[postIndex]?.is_like == 2 }"
                    >
                      <svg
                        v-if="post_list?.[postIndex]?.is_like == 1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                        />
                      </svg>
                      <svg
                        v-if="post_list?.[postIndex]?.is_like == 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                        />
                      </svg>

                      <div class="thumbNum">
                        {{ post_list?.[postIndex]?.likes }}
                      </div>
                    </div>
                    <div class="optionThumb">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
                        />
                      </svg>
                      <div class="thumbNum">
                        {{ post_list?.[postIndex]?.comments_count }}
                      </div>
                    </div>
                    <div
                      @click="shareContent(post_list?.[postIndex]?.id)"
                      class="optionThumb"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                        />
                      </svg>
                    </div>
                  </div>
                  <!-- <div
                    class="optionsList"
                    @click="save_favorit(post_list[postIndex]?.id)"
                  >
                    <div class="optionThumb">
                      <svg
                        v-if="post_list[postIndex]?.is_favorite == 1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
                        />
                      </svg>
                      <svg
                        v-if="post_list[postIndex]?.is_favorite == 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div> -->
                </div>
                <div
                  v-if="
                    postCommentsList.length > 0 && !commentsLoademoreLoading
                  "
                  class="mainList"
                >
                  <div
                    v-for="(CommentUserLists, i) in postCommentsList"
                    :key="i"
                    class="listThumb"
                  >
                    <div class="listThumbWrapper">
                      <div class="thumbPic">
                        <img
                          :src="CommentUserLists.avatar"
                          :alt="CommentUserLists.name"
                        />
                      </div>
                      <div class="thumbContent">
                        <div class="contentDesc">
                          <span class="userTitle">{{
                            CommentUserLists.name
                          }}</span>
                          {{ CommentUserLists.description }}
                        </div>
                        <div class="contentDetails">
                          <div class="detailsTime">
                            {{ CommentUserLists.date }}
                          </div>
                          <div
                            class="detailsReply"
                            @click="post_replay_focuse(CommentUserLists.id)"
                          >
                            پاسخ دادن
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="thumbReplyList">
                      <div
                        v-for="(replaies, j) in CommentUserLists.replay"
                        :key="j"
                        class="listThumb"
                      >
                        <div class="listThumbWrapper">
                          <div class="thumbPic">
                            <img :src="replaies.avatar" :alt="replaies.name" />
                          </div>
                          <div class="thumbContent">
                            <div class="contentDesc">
                              <span class="userTitle">{{ replaies.name }}</span>
                              {{ replaies.description }}
                            </div>
                            <div class="contentDetails">
                              <div class="detailsTime">
                                {{ replaies.date }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mobileNocomments"
                  v-if="
                    postCommentsList.length == 0 && !commentsLoademoreLoading
                  "
                >
                  نظری ثبت نشده است
                </div>
                <div class="loadeMoreLoader" v-if="commentsLoademoreLoading">
                  <span class="custom-loader"></span>
                </div>
              </div>
              <div class="contentFooter">
                <div class="footerFooter">
                  <div v-if="$store.getters.auth.loggedIn" class="footerGroup">
                    <div
                      v-if="!post_comment_btn_loading"
                      @click="postCommentsSaveHandler(0, 'mob')"
                      class="groupButton"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                      >
                        <path
                          d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
                        />
                      </svg>
                    </div>
                    <div v-if="post_comment_btn_loading" class="groupButton">
                      <span class="postCommentloader"></span>
                    </div>
                    <input
                      type="text"
                      class="groupInput"
                      id="postComment"
                      :class="{ reply: postParent_id != 0 }"
                      placeholder="کامنت خود را بنویسید"
                      v-model="postNewComment"
                    />
                    <div
                      v-if="postParent_id !== 0"
                      class="cancleReply"
                      @click="replay_blur"
                    >
                      انصراف
                    </div>
                  </div>
                  <div
                    v-if="!$store.getters.auth.loggedIn"
                    class="loginAlerContainer"
                  >
                    <div class="loginAler">
                      برای ثبت نظر وارد حساب کاربری شوید
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showFollowed"
      align-center
      class="followListDialog"
      @close="selectedFollowClose"
    >
      <div class="followedList">
        <div class="followListNav">
          <div class="navTitle">
            <span v-if="selectedFollow == 'follower'">دنبال کنندگان</span>
            <span v-if="selectedFollow == 'following'">دنبال شوندگان</span>
          </div>
          <div class="navBackBtn">
            <div class="backBtn" @click="selectedFollowClose(true)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="followedListWrapper">
          <div class="headerWrapper">
            <div
              class="listHeader"
              :class="[selectedFollow == 'follower' ? 'follower' : 'following']"
            >
              <div class="headerSwitch"></div>
              <div
                class="headerBtn follower"
                :class="{ selected: selectedFollow == 'follower' }"
                @click="selectedFollowHandler('follower')"
              >
                دنبال کنندگان
              </div>
              <div
                class="headerBtn following"
                :class="{ selected: selectedFollow == 'following' }"
                @click="selectedFollowHandler('following')"
              >
                دنبال شوندگان
              </div>
            </div>
          </div>
          <div class="listContent">
            <!--            following-->
            <el-scrollbar
              v-if="selectedFollow == 'following'"
              ref="usersList"
              class="usersList followingList"
              :height="followListHeight"
            >
              <div v-if="following.loading && following.list.length === 0">
                <div v-for="n in 3" :key="n" class="skeleton-wrapper">
                  <div class="TopShowToUSerNAme">
                    <div class="ImageTopShowToUSerNAme"></div>
                    <div
                      class="titleTopShowToUSerNAme"
                      style="width: 90%"
                    ></div>
                  </div>
                </div>
              </div>

              <div v-if="!following.loading && following.list.length > 0">
                <div
                  class="userThumb"
                  v-for="(v, i) in following.list"
                  :key="i"
                  @click="profileRouteHandler(v)"
                >
                  <div class="userInfo">
                    <div class="userProfile">
                      <img :src="v.avatar" alt="" />
                    </div>
                    <div class="userName">{{ v.nickname }}</div>
                  </div>
                  <!-- <div
                    class="userBtn"
                    v-if="
                      userInforamtion &&
                      userInforamtion.uid != v.uid &&
                      user_info.uid == $store.state.auth.uid
                    "
                  >

                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                  </div> -->

                  <div
                    class="userBtn"
                    v-if="userInforamtion && userInforamtion.uid != v.uid"
                  >
                    <div
                      class="followBtn"
                      v-if="!v.isfollower && !follow_btn_loading[i]"
                      @click.stop="
                        follow_list_btn(v.uid, i, 'follow', 'following')
                      "
                    >
                      دنبال کردن
                    </div>
                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                    <div
                      class="followBtn unfollowBtn"
                      v-if="!follow_btn_loading[i] && v.isfollower"
                      @click.stop="
                        follow_list_btn(v.uid, i, 'unfollow', 'following')
                      "
                    >
                      لغو دنبال کردن
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="following.list.length === 0 && !following.loading"
                class="no-result"
              >
                <p>دنبال شونده ای یافت نشد</p>
              </div>

              <!-- Loading indicator برای lazy loading -->
              <div v-if="following.lazyLoading" class="lazy-loading-indicator">
                <div class="loading-spinner"></div>
                <p>در حال بارگذاری...</p>
              </div>
            </el-scrollbar>

            <!--            follower-->
            <el-scrollbar
              v-if="selectedFollow == 'follower'"
              id="usersList"
              class="usersList followerList"
              :height="followListHeight"
            >
              <div v-if="follower.loading && follower.list.length === 0">
                <!--              <div >-->
                <div v-for="n in 10" :key="n" class="skeleton-wrapper">
                  <div class="TopShowToUSerNAme">
                    <div class="ImageTopShowToUSerNAme"></div>
                    <div
                      class="titleTopShowToUSerNAme"
                      style="width: 90%"
                    ></div>
                  </div>
                </div>
              </div>

              <div v-if="!follower.loading && follower.list.length > 0">
                <div
                  class="userThumb"
                  v-for="(v, i) in follower.list"
                  :key="i"
                  @click="profileRouteHandler(v)"
                >
                  <div class="userInfo">
                    <div class="userProfile">
                      <img :src="v.avatar" alt="" />
                    </div>
                    <div class="userName">{{ v.nickname }}</div>
                  </div>
                  <div
                    class="userBtn"
                    v-if="userInforamtion && userInforamtion.uid != v.uid"
                  >
                    <div
                      class="followBtn"
                      v-if="!v.isfollowing && !follow_btn_loading[i]"
                      @click.stop="follow_list_btn(v.uid, i, 'follow')"
                    >
                      دنبال کردن
                    </div>
                    <div
                      class="followBtn"
                      style="padding: 0"
                      v-if="follow_btn_loading[i]"
                    >
                      <span
                        class="loader"
                        style="width: 18px !important; height: 18px !important"
                      ></span>
                    </div>
                    <div
                      class="followBtn unfollowBtn"
                      v-if="!follow_btn_loading[i] && v.isfollowing"
                      @click.stop="follow_list_btn(v.uid, i, 'unfollow')"
                    >
                      لغو دنبال کردن
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="follower.list.length === 0 && !follower.loading"
                class="no-result"
              >
                <p>دنبال کننده ای یافت نشد</p>
              </div>

              <!-- Loading indicator برای lazy loading -->
              <div v-if="follower.lazyLoading" class="lazy-loading-indicator">
                <div class="loading-spinner"></div>
                <p>در حال بارگذاری...</p>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </el-dialog>

    <div
      @click="profileCloseHandler"
      v-if="ShowModel"
      role="dialog"
      class="j-modal"
      style="--padding-left: 0px; --padding-right: -17px"
    >
      <div @click.stop class="product-modal">
        <header class="product-modal-header">
          <p class="product-modal-header__title">ویرایش پروفایل</p>

          <div
            class="divCreateAdvisorsButton desktopEditBtn"
            v-if="!btn_loading"
            @click="send_edit_data()"
          >
            ویرایش
          </div>
          <div
            class="divCreateAdvisorsButton desktopEditBtn"
            style="cursor: not-allowed"
            v-if="btn_loading"
          >
            <span class="loader"></span>
            <span> ویرایش</span>
          </div>
          <div
            @click="profileCloseHandler"
            role="button"
            class="product-modal-header__close"
          ></div>
        </header>
        <div class="product-modal-content">
          <div class="product-modal-content__container">
            <el-scrollbar :style="editStyle" :max-height="editHeight">
              <div style="margin-bottom: 10px" class="ProfileSetCreate">
                <div id="imageBox" @click="openFileInput">
                  <input
                    type="file"
                    ref="fileInput"
                    accept="image/*"
                    @change="previewImage"
                    style="display: none"
                  />
                  <img
                    v-if="imageSrc"
                    :src="imageSrc"
                    id="imagePreview"
                    :alt="user_info.nickname"
                  />
                  <img
                    v-if="!imageSrc"
                    :src="completeInfos?.avatar"
                    id="imagePreview"
                    :alt="user_info.nickname"
                  />

                  <button
                    v-if="imageSrc"
                    class="delete-button"
                    @click.stop="removeImage"
                  >
                    <!-- <VsxIcon
                      iconName="GalleryRemove"
                      :size="25"
                      color="red"
                      type="linear"
                    /> -->
                    <i class="fas fa-trash"></i>
                  </button>
                  <button v-if="!imageSrc" class="add-button">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div class="addPic_text">انتخاب عکس پروفایل</div>
              </div>

              <div class="ShowInputFormToUser1">
                <div class="ChildShowInputFormToUser">
                  <label>نام<span>*</span></label>
                  <input type="text" maxlength="50" v-model="user_info.fname" />
                </div>
                <div class="ChildShowInputFormToUser">
                  <label>نام خانوادگی<span>*</span></label>
                  <input type="text" maxlength="50" v-model="user_info.lname" />
                </div>
                <div class="ChildShowInputFormToUser">
                  <label>نام شرکت</label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="user_info.company_name"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>کد ملی<span>*</span></label>
                  <input
                    type="tel"
                    maxlength="11"
                    inputmode="numeric"
                    v-model="user_info.code_melli"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>شماره تماس همراه<span>*</span></label>
                  <input
                    type="tel"
                    maxlength="11"
                    inputmode="numeric"
                    v-model="user_info.mobile"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>شماره تماس دفتر</label>
                  <input
                    type="tel"
                    maxlength="11"
                    inputmode="numeric"
                    v-model="user_info.phone"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>آدرس دفتر کار<span>*</span></label>
                  <input type="text" v-model="user_info.address" />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>منطقه فعالیت<span>*</span></label>
                  <el-select
                    v-model="user_info.category_id"
                    multiple
                    collapse-tags
                    collapse-tags-tooltip
                    placeholder=""
                  >
                    <el-option
                      v-for="(v, i) in district_list"
                      :key="i"
                      :value="v.id"
                      :label="v.title"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="ChildShowInputFormToUser activityType">
                  <label>نوع فعالیت</label>
                  <div class="activityOptionsList">
                    <div class="listWrapper">
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="aprtment"
                          value="apartment"
                          :checked="
                            user_info.b_activity_type.includes('apartment')
                          "
                          @change="handleCheckboxChange($event, 'apartment')"
                          class="hiddenInput"
                        />
                        <label for="aprtment" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('apartment'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="aprtment" class="filterListTitle">
                          آپارتمان سازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="villa"
                          value="villa"
                          :checked="user_info.b_activity_type.includes('villa')"
                          @change="handleCheckboxChange($event, 'villa')"
                          class="hiddenInput"
                        />
                        <label for="villa" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('villa'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="villa" class="filterListTitle">
                          ویلا سازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="commercial"
                          value="commercial"
                          :checked="
                            user_info.b_activity_type.includes('commercial')
                          "
                          @change="handleCheckboxChange($event, 'commercial')"
                          class="hiddenInput"
                        />
                        <label for="commercial" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes(
                                  'commercial'
                                ),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="commercial" class="filterListTitle">
                          تجاری سازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="rebuild"
                          value="rebuild"
                          :checked="
                            user_info.b_activity_type.includes('rebuild')
                          "
                          @change="handleCheckboxChange($event, 'rebuild')"
                          class="hiddenInput"
                        />
                        <label for="rebuild" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('rebuild'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="rebuild" class="filterListTitle">
                          بازسازی
                        </label>
                      </div>
                      <div class="listThumb">
                        <input
                          type="checkbox"
                          id="other"
                          value="other"
                          :checked="user_info.b_activity_type.includes('other')"
                          @change="handleCheckboxChange($event, 'other')"
                          class="hiddenInput"
                        />
                        <label for="other" class="filterListInput">
                          <div
                            class="customCheckBox"
                            :class="{
                              checked:
                                user_info.b_activity_type.includes('other'),
                            }"
                          >
                            <div class="checkedTick">
                              <i class="fa-solid fa-check"></i>
                            </div>
                          </div>
                        </label>
                        <label for="other" class="filterListTitle">
                          سایر
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ChildShowInputFormToUser activityType">
                  <label>سال شروع فعالیت</label>

                  <el-select placeholder="" v-model="user_info.work_history">
                    <el-option
                      v-for="(year, index) in years"
                      :key="index"
                      :label="year"
                      :value="year"
                    />
                    <el-option :value="'before'" :label="'قبل از سال 1370'" />
                  </el-select>
                </div>

                <div class="ChildShowInputFormToUser activityType">
                  <label>درباره من</label>
                  <textarea v-model="user_info.description" rows="2"></textarea>
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>آدرس تلگرام</label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="user_info.telegram"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>آدرس واتس اپ</label>
                  <input
                    type="text"
                    maxlength="50"
                    v-model="user_info.whats_app"
                  />
                </div>

                <div class="ChildShowInputFormToUser">
                  <label>آدرس اینستاگرام</label>
                  <input type="text" maxlength="50" v-model="user_info.insta" />
                </div>
                <div class="resProfileEditBtn" @click="send_edit_data">
                  <span v-if="!btn_loading">ویرایش</span>
                  <span v-if="btn_loading" class="loader"></span>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div class="j-modal__overly"></div>
    </div>
    <div
      v-if="desktopCommentsModal"
      class="vue-portal-target"
      @click="desktopMOdalHandler"
    >
      <div
        role="dialog"
        class="j-modal"
        style="--padding-left: 0px; --padding-right: -17px"
      >
        <article class="comments-modal" @click.stop>
          <header class="comments-modal-header">
            <h2 class="comments-modal-header__title">نظرات کاربران</h2>
            <button
              class="comments-modal-header__close"
              @click="desktopMOdalHandler"
            >
              <i class="fas fa-xmark"></i>
              <!-- <VsxIcon
                iconName="CloseCircle"
                :size="21"
                color="#000"
                type="linear"
              /> -->
            </button>
          </header>

          <div class="comments-modal-body">
            <div class="commentsDestopBody">
              <div class="commentsList">
                <div class="commentInputWrapper newCommentInput">
                  <div
                    v-if="$store.getters.auth.loggedIn"
                    class="inputUserProfile"
                  ></div>

                  <div v-if="$store.getters.auth.loggedIn" class="commentInput">
                    <div class="addCommentInput" :class="{ focus: isFocus }">
                      <input
                        type="text"
                        v-model="newComment"
                        placeholder="نظر خود را وارد کنید"
                        @focus="inputFocusHandler"
                        @blur="inputFocusHandler"
                      />
                    </div>

                    <div class="commentInputBtns">
                      <div
                        v-if="info_list.uid != $store.state.auth.uid"
                        class="rateBtn"
                      >
                        <el-rate
                          v-if="!loadingRate"
                          v-model="rate"
                          :disabled="info_list.myset_rate > 0"
                        />
                        <el-rate v-if="loadingRate" v-model="rate" />
                      </div>

                      <div
                        v-if="!comment_btn_loading"
                        class="commentBtn"
                        :class="{ disabled: newComment === '' }"
                        @click="save_comment()"
                      >
                        ثبت نظر
                      </div>
                      <div
                        v-if="comment_btn_loading"
                        class="commentBtn"
                        :class="{ disabled: newComment === '' }"
                      >
                        <span class="loader"></span>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="!$store.getters.auth.loggedIn"
                    class="commentInput"
                  >
                    برای ثبت نظر وارد حساب کاربری شوید
                  </div>
                </div>
                <div
                  class="commentThumb"
                  v-for="(CommentUserLists, i) in CommentUserList"
                  :key="i"
                >
                  <div class="commentProfile">
                    <img :src="CommentUserLists.avatar" />
                  </div>
                  <div class="commentContent">
                    <div class="commentHeader">
                      <h6 class="userName">{{ CommentUserLists.name }}</h6>
                      <!--                      <el-rate size="small" />-->
                      <!-- <div class="commentDate">{{ CommentUserLists.date }}</div> -->
                    </div>
                    <div class="commentText">
                      {{ CommentUserLists.description }}
                    </div>
                    <div class="commentBtns">
                      <div class="commentLikesBtn">
                        <!--                      <div class="likeBtnWrapper">-->
                        <!--                        <div class="likeBtn">-->
                        <!--                          <VsxIcon-->
                        <!--                            class="commentBtnIcon"-->
                        <!--                            iconName="Like1"-->
                        <!--                            :size="24"-->
                        <!--                            type="linear"-->
                        <!--                          />-->
                        <!--                        </div>-->
                        <!--                        <div class="likeNum">232</div>-->
                        <!--                      </div>-->
                        <!--                      <div class="disLikeBtn">-->
                        <!--                        <VsxIcon-->
                        <!--                          class="commentBtnIcon"-->
                        <!--                          iconName="Dislike"-->
                        <!--                          :size="24"-->
                        <!--                          type="linear"-->
                        <!--                        />-->
                        <!--                      </div>-->
                      </div>
                      <div
                        class="commentReplyBtn"
                        @click="replyCommentHandler(i)"
                      >
                        پاسخ دهید
                      </div>
                    </div>
                    <div
                      class="commentInputWrapper"
                      :class="{ show: replyComment === i }"
                    >
                      <div class="inputUserProfile"></div>
                      <div class="commentInput">
                        <div
                          class="addCommentInput"
                          :class="{ focus: isFocus }"
                        >
                          <input
                            type="text"
                            v-model="comment_replay[CommentUserLists.id]"
                            placeholder="نظر خود را وارد کنید"
                            @focus="inputFocusHandler"
                            @blur="inputFocusHandler"
                          />
                        </div>

                        <div class="commentInputBtns">
                          <div
                            class="cancleBtn"
                            @click="replyCommentCloseHandler"
                          >
                            انصراف
                          </div>
                          <div
                            v-if="
                              !comment_btn_replay_loading[CommentUserLists.id]
                            "
                            class="commentBtn"
                            :class="{
                              disabled:
                                comment_replay[CommentUserLists.id] === '',
                            }"
                            @click="save_comment(CommentUserLists.id)"
                          >
                            ثبت نظر
                          </div>
                          <div
                            v-if="
                              comment_btn_replay_loading[CommentUserLists.id]
                            "
                            class="commentBtn"
                            :class="{
                              disabled:
                                comment_replay[CommentUserLists.id] === '',
                            }"
                          >
                            <span class="loader"></span>
                            <span style="margin-right: 5px"> ثبت نظر</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="commentsReplyToggler">
                      <div
                        class="commentsReplyToggleBtn"
                        @click="replyToggleHandler(i)"
                      >
                        <VsxIcon
                          v-show="i !== showReply"
                          iconName="ArrowDown2"
                          :size="20"
                          color="#0096c7"
                          type="linear"
                        />
                        <VsxIcon
                          v-show="i === showReply"
                          iconName="ArrowUp2"
                          :size="20"
                          color="#0096c7"
                          type="linear"
                        />
                        {{ CommentUserLists.replay.length }} پاسخ
                      </div>
                    </div>
                    <div
                      class="commentsReply"
                      :class="{ show: showReply === i }"
                    >
                      <div
                        class="commentThumb"
                        v-for="(replay, i) in CommentUserLists.replay"
                        :key="i"
                      >
                        <div class="commentProfile">
                          <img :src="CommentUserLists.avatar" />
                        </div>
                        <div class="commentContent">
                          <div class="commentHeader">
                            <h6 class="userName">{{ replay.name }}</h6>
                            <div class="commentDate">{{ replay.date }}</div>
                          </div>
                          <div class="commentText">
                            {{ replay.description }}
                          </div>
                          <!--                          <div class="commentBtns">-->
                          <!--                            <div class="commentLikesBtn">-->
                          <!--                              <div class="likeBtnWrapper">-->
                          <!--                                <div class="likeBtn">-->
                          <!--                                  <VsxIcon-->
                          <!--                                      class="commentBtnIcon"-->
                          <!--                                      iconName="Like1"-->
                          <!--                                      :size="24"-->
                          <!--                                      color="#000"-->
                          <!--                                      type="linear"-->
                          <!--                                  />-->
                          <!--                                </div>-->
                          <!--                                <div class="likeNum">232</div>-->
                          <!--                              </div>-->
                          <!--                              <div class="disLikeBtn">-->
                          <!--                                <VsxIcon-->
                          <!--                                    class="commentBtnIcon"-->
                          <!--                                    iconName="Dislike"-->
                          <!--                                    :size="24"-->
                          <!--                                    color="#000"-->
                          <!--                                    type="linear"-->
                          <!--                                />-->
                          <!--                              </div>-->
                          <!--                            </div>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                      <div class="loadeMoreLoader" v-if="loadmore_loading">
                        <span class="custom-loader"></span>
                      </div>
                      <div
                        v-show="CommentUserList.length === 0"
                        ref="loadMoreTrigger2"
                        class="trigger"
                      ></div>
                    </div>
                  </div>
                </div>
                <div v-if="CommentUserList.length === 0" class="noComments">
                  هیچ نظری ثبت نشده است
                </div>
                <div
                  class="loadeMoreLoader"
                  v-if="
                    loadmore_loading_comment && CommentUserList.length !== 0
                  "
                >
                  <span class="custom-loader"></span>
                </div>
              </div>
            </div>
          </div>
        </article>
        <div class="j-modal__overly"></div>
      </div>
    </div>
    <vue-bottom-sheet :open="commentSheet" ref="myBottomSheet">
      <div class="ShowCommandBoxesMyBottomSheet">
        <el-scrollbar
          height="384px"
          class="commentListWrapper"
          @scroll="handleScrollComment"
        >
          <div
            v-for="(CommentUserLists, i) in CommentUserList"
            :key="i"
            class="AllChildCommentRefSheet"
          >
            <div class="ChildCommentRefSheetVg">
              <div class="ChildCommentRefSheet">
                <div class="ImageChildCommentRefSheet">
                  <img
                    :src="CommentUserLists.avatar"
                    :alt="CommentUserLists.name"
                  />
                </div>
                <div class="TitleChildCommentRefSheet">
                  <div class="TitleChildCommentRefSheetTitle">
                    <h1>
                      {{ CommentUserLists.name }}
                    </h1>
                    <!--                  <el-rate size="small" />-->
                  </div>
                  <p>
                    {{ CommentUserLists.description }}
                  </p>
                </div>
              </div>

              <VsxIcon
                iconName="MessageAdd1"
                :size="25"
                color="#0096c7"
                type="bold"
              />
            </div>

            <div
              v-for="(replaies, i) in CommentUserLists.replay"
              :key="i"
              class="ReplayChildCommentRefSheet"
            >
              <VsxIcon
                style="margin-left: 10px"
                iconName="Data2"
                :size="20"
                color="#999"
                type="linear"
              />
              <div class="ImageChildCommentRefSheet">
                <img :src="replaies.avatar" :alt="replaies.name" />
              </div>
              <div class="TitleChildCommentRefSheet">
                <h1>
                  {{ replaies.name }}
                </h1>
                <p>
                  {{ replaies.description }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="mobileNocomments"
            v-if="CommentUserList.length == 0 && !loadmore_loading_comment"
          >
            نظری ثبت نشده است
          </div>
          <div class="loadeMoreLoader" v-if="loadmore_loading_comment">
            <span class="custom-loader"></span>
          </div>
        </el-scrollbar>
        <div class="dentMessageToCommentSpace"></div>

        <div class="dentMessageToCommentWrapper">
          <div
            v-if="info_list.uid != $store.state.auth.uid"
            class="commentRatingComp"
          >
            <span>امتیاز شما:</span>
            <el-rate
              v-if="!loadingRate"
              v-model="rate"
              :disabled="info_list.myset_rate > 0"
              size="large"
            />
            <el-rate v-if="loadingRate" v-model="rate" />
          </div>
          <div
            v-if="!$store.getters.auth.loggedIn"
            class="dentMessageToComment"
          >
            <span class="loginMessage">
              برای ثبت نظر وارد حساب کاربری شوید
            </span>
          </div>
          <div v-else class="dentMessageToComment">
            <div class="sendCommentBtnWrapper">
              <div
                class="sendCommentBtn"
                v-if="!comment_btn_loading && !$store.state.auth.loggedIn"
                @click="showLoginBox"
              >
                <i class="fa-solid fa-paper-plane"></i>
              </div>
              <div
                class="sendCommentBtn"
                v-if="!comment_btn_loading && $store.state.auth.loggedIn"
                @click="save_comment(0, 'mob')"
              >
                <i class="fa-solid fa-paper-plane"></i>
              </div>

              <span v-if="comment_btn_loading" class="loader"></span>
            </div>

            <div class="mobileNewCommentInput">
              <input
                type="text"
                id="newComment_mob"
                v-model="newComment"
                :style="parent_id === 0 ? 'width: 100%;' : 'width: 82%'"
              />
            </div>
            <div
              v-if="parent_id !== 0"
              class="cancleReply"
              @click="replay_blur"
            >
              انصراف
            </div>
          </div>
        </div>
      </div>
    </vue-bottom-sheet>
    <LoginUser @close="ShowLoginBoxes = false" v-if="ShowLoginBoxes" />
    <editMelk v-if="showEdit" :postId="postId" @close="editFileCloseHandler" />
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";
// import DatePicker from "@alireza-ab/vue3-persian-datepicker";
import Compressor from "compressorjs";
import axios from "axios";
import { nextTick } from "vue";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import LoginUser from "./LoginUser.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Share } from "@capacitor/share";
import editMelk from "@/components/profile/editMelk.vue";

export default {
  name: "instagramProfile",
  components: {
    Skeletor,
    // DatePicker,
    VueBottomSheet,
    LoginUser,
    Swiper,
    SwiperSlide,
    editMelk,
  },
  data() {
    return {
      resShowMore: false,
      module: [Navigation, Pagination],
      showEdit: false,
      postId: 0,
      rateNum: 0,
      isBackAction: false,
      userInforamtion: null,
      selectedFollow: "",
      commentSheet: false,
      addComentModal: false,
      desktopCommentsModal: false,
      btn_loading: false,
      ShowModel: false,
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      LoadingSkeleton: true,
      loadingFollow: false,
      overlays: Array(9).fill(false),
      showDeskOption: false,
      // optionSheet: false,
      page: 1,
      info_list: [],
      post_list: [],
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,
      myprofile: false,
      mode: "",
      imageSrc: null,
      map: null,
      reloadKey: 0,
      markersLayer: null,
      markerOne: null,
      loadMoreTrigger: null,
      center: { latitude: 36.5663854, longitude: 52.6707147 },
      markerPosition: { longitude: 0, latitude: 0 },
      houseIcon: L.divIcon({
        html: `
          <div style="position: relative;">
            <div style="
              position: absolute;
              width: 70px;
              height: 70px;
              background: rgba(0, 0, 0, 0.2);
              border-radius: 50%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "></div>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="67" height="67" viewBox="0 0 67 67">
                <defs>
                    <filter id="cxwfhygxxa" width="211.1%" height="211.1%" x="-55.6%" y="-55.6%" filterUnits="objectBoundingBox">
                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/>
                        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.461511145 0"/>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                    <path id="m1l7efvoab" d="M15.317 5.098L8.435.183c-.341-.244-.8-.244-1.142 0L.412 5.098c-.442.316-.544.93-.229 1.371.315.443.93.544 1.371.23l.412-.295v8.341c0 .543.44.983.983.983h9.83c.544 0 .983-.44.983-.983v-8.34c.343.244.587.476.982.476.308 0 .61-.143.801-.412.316-.441.213-1.055-.228-1.371zm-3.52 8.664H9.83v-2.949c0-1.086-.88-1.966-1.966-1.966-1.086 0-1.966.88-1.966 1.966v2.95H3.932V5L7.864 2.19 11.796 5v8.762z"/>
                </defs>
                <g fill="none" fill-rule="evenodd" filter="url(#cxwfhygxxa)" transform="translate(15.127 15.127)">
                    <rect width="32.887" height="32.887" x="1.43" y="1.43" fill="#213743" stroke="#192B37" stroke-width="2.86" rx="8.579"/>
                    <g transform="translate(10.009 10.009)">
                        <mask id="wd87vlifuc" fill="#fff">
                            <use xlink:href="#m1l7efvoab"/>
                        </mask>
                        <use fill="#000" fill-rule="nonzero" xlink:href="#m1l7efvoab"/>
                        <g fill="#FFF" mask="url(#wd87vlifuc)">
                            <path d="M0 0H15.728V15.728H0z"/>
                        </g>
                    </g>
                </g>
            </svg>
          </div>`,
        className: "house-marker",
        iconSize: [70, 70],
        iconAnchor: [35, 35],
      }),
      user_info: {
        avatar: "",
        uid: "",
        role: "builder",
        fname: "",
        lname: "",
        company_name: "",
        mobile: "",
        code_melli: "",
        address: "",
        phone: "",
        category_id: [],
        b_activity_type: [],
        work_history: "",
        description: "",
        telegram: "",
        whats_app: "",
        insta: "",
      },
      comment_btn_loading: false,
      CommentUserList: [],
      newComment: "",
      showReply: -1,
      replyComment: -1,
      comment_replay: [],
      comment_btn_replay_loading: [],
      parent_id: 0,
      page_comment: 1,
      isLoading_comment: true,
      loadmore_comment: false,
      loadmore_loading_comment: false,
      total_comment: 0,
      userStory: [],
      isDialogOpen: false,
      storyOpen: false,
      loadMoreTrigger2: null,
      CommentloadMoreTrigger: null,
      ShowLoginBoxes: false,
      follower: {
        hasMorePages: true,
        lazyLoading: false,
        loading: true,
        page: 1,
        list: [],
        LoadingSkeleton: true,
      },
      following: {
        hasMorePages: true,
        lazyLoading: false,
        loading: true,
        page: 1,
        list: [],
        LoadingSkeleton: true,
      },
      follow_btn_loading: [],
      scrollEl: null,
      followListHeight: "50vh",
      rate: 0,
      loadingRate: false,
      editStyle: "padding: 0 30px; padding-bottom: 30px;",
      editHeight: "70vh",
      showDetails: false,
      form: {
        page: 1,
        per_page: 16,
        main_category: "all",
        post_type: "portfolio",
      },
      postList: [],
      postIndex: 0,
      Commentpage: 1,
      commentsTotal: 0,
      postCommentsList: [],
      commentsLoadeMore: true,
      commentsLoading: false,
      commentsLoademoreLoading: false,
      postComment_btn_replay_loading: [],
      postParent_id: 0,
      postNewComment: "",
      post_comment_replay: [],
      post_comment_btn_loading: false,
      postreplyComment: -1,
      completeInfos: [],
      postSwiper: null,
      district_list: [],
      years: [],
      postType: "portfolio",
      filterLoading: false,
    };
  },
  computed: {
    showFollowed() {
      return this.selectedFollow !== "";
    },
  },
  methods: {
    formattedDetails(content) {
      return content ? content.replace(/(\r\n|\n|\r)/g, "<br>") : "";
    },
    async initializeMap() {
      try {
        if (!this.map) {
          this.map = L.map("map", {
            dragging: true,
            touchZoom: true,
            scrollWheelZoom: true,
            doubleClickZoom: true,
            boxZoom: true,
            keyboard: true,
            zoomControl: true,
          });

          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 20,
            minZoom: 5,
            attribution: "© OpenStreetMap Abarline",
          }).addTo(this.map);
        }

        this.updateMapLocation();
      } catch (error) {
        console.error("Map initialization error:", error);
      }
    },
    updateMapLocation() {
      const lat = this.post_list?.[this.postIndex]?.lat;
      const lng = this.post_list?.[this.postIndex]?.lng;

      if (!lat || !lng) return;

      this.map.setView([lat, lng], 16);

      if (this.markerOne) {
        this.map.removeLayer(this.markerOne);
      }

      this.markerOne = L.marker([lat, lng], { icon: this.houseIcon }).addTo(
        this.map
      );

      this.map.invalidateSize();
    },

    getmounted(map) {
      this.map = map;
      this.initializeMap(map);
    },
    postTypeHanlder(type) {
      this.postType = type;
      this.filterLoading = true;
      this.$nextTick(() => {
        this.user_info_func("first");
      });
    },
    onSwiperInitialized(swiper) {
      this.postSwiper = swiper;
    },
    getPostHandler() {
      this.helperPost("public-post-list", this.form).then((response) => {
        if (response.data.result == "1") {
          this.postList = response.data.data.list;
        }
      });
    },
    profileDetailsOpenHandler(post, index) {
      if (window.innerWidth > 1000) {
        this.showDetails = true;
        if (this.postSwiper) {
          this.postSwiper.slideTo(0);
        }
        this.postIndex = index;
        this.postCommentLoadHandler("first");
        this.$nextTick(() => {
          this.setupScrollListener();
          if (this.map) {
            this.map.remove();
            this.map = null;
            this.markerOne = null;
          }

          this.$nextTick(() => {
            this.initializeMap();
          });
        });
      } else {
        this.$router.push(
          `/builder-details/${this.$store.state.auth.uid}/${post.id}`
        );
        localStorage.setItem(
          "completeInfos",
          JSON.stringify(this.completeInfos)
        );
      }
    },
    profileDetailsCloseHandler() {
      this.showDetails = false;
    },
    postIndexIncrease() {
      if (this.postIndex < this.post_list.length - 1) {
        this.postIndex++;
        this.postCommentLoadHandler("first");
        console.log("this.postSwiper", this.postSwiper);
        if (this.postSwiper) {
          this.postSwiper.slideTo(0, 0);
        }
        this.$nextTick(() => {
          this.updateMapLocation();
        });
      }
    },
    postIndexDecrease() {
      if (this.postIndex > 0) {
        this.postIndex--;
        this.postCommentLoadHandler("first");
        if (this.postSwiper) {
          this.postSwiper.slideTo(0, 0);
        }
        this.$nextTick(() => {
          this.updateMapLocation();
        });
      }
    },
    editStyleHandler() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        this.editStyle = "padding: 0 16px; padding-bottom: 24px;";
        this.editHeight = "90vh";
      }
    },
    editFileOpenHandler(id) {
      this.postId = id;
      this.showEdit = true;
      history.pushState(null, "", location.href);
    },
    editFileCloseHandler() {
      history.back();
      setTimeout(() => {
        this.postId = 0;
        this.showEdit = false;
      }, 500);
    },
    handleFollowHeight() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        this.followListHeight = "calc(100vh - 150px)";
      }
    },
    follow_list_btn(target_id, i, state, from) {
      var user_id = this.$store.state.auth.uid;
      this.follow_btn_loading[i] = true;
      this.helperPost("follow", {
        uid: user_id,
        target_id: target_id,
      }).then((r) => {
        console.log(r);
        if (state == "unfollow") {
          if (this.info_list.uid == this.$store.state.auth.uid) {
            this.following.list.splice(i, 1);
          }
          if (from == "following") this.following.list[i].isfollower = 0;
          else this.follower.list[i].isfollowing = 0;
        } else {
          if (from == "following") this.following.list[i].isfollower = 1;
          else this.follower.list[i].isfollowing = 1;
        }
        this.follow_btn_loading[i] = false;
        this.getCustomerinfo();
      });
    },

    getCustomerinfo() {
      let self = this;
      this.helperPost("current-user-info")
        .then((r) => {
          if (r.data.result == "1") {
            self.$store.commit("setAuth", r.data);
            self.$store.dispatch("checkAuth");
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    // handleScroll() {
    //   const scrollbar = document.querySelector(".followerList");
    //   console.log(
    //     "qq",
    //     scrollbar,
    //     this.follower.lazyLoading,
    //     this.follower.hasMorePages
    //   );
    //   // if (this.follower.lazyLoading || !this.follower.hasMorePages)
    //   //   return;

    //   const scrollPosition = scrollbar.scrollTop + scrollbar.clientHeight;
    //   const scrollHeight = scrollbar.scrollHeight;

    //   console.log(scrollPosition, scrollHeight);

    //   if (scrollPosition >= scrollHeight * 0.9) {
    //     this.loadMore();
    //   }
    // },

    // async loadMore() {
    //   if (this.follower.hasMorePages && !this.follower.lazyLoading) {
    //     this.follower.lazyLoading = true;
    //     this.follower.page++;
    //     await this.getfollower();
    //     this.follower.lazyLoading = false;
    //   }
    // },
    handleScroll(e) {
      const target = e.target;
      let currentState =
        this.selectedFollow === "follower" ? this.follower : this.following;

      if (!target || currentState.lazyLoading || !currentState.hasMorePages) {
        return;
      }

      const scrollPosition = target.scrollTop + target.clientHeight;
      const scrollHeight = target.scrollHeight;

      if (scrollPosition >= scrollHeight - 10) {
        if (this.selectedFollow === "follower") {
          this.loadMoreFollower();
        } else {
          this.loadMoreFollowing();
        }
      }
    },
    profileRouteHandler(user) {
      if (user.role == 'branch_admin') {
        this.$router.push({ path: "/profile-amlak", query: { bid: user.branch_id } });
      } else if (user.role == 'builder') {
        this.$router.push({ path: "/profile-builder", query: { uid: user.uid } });
      } else
        this.$router.push({ path: "/profile-superior", query: { uid: user.uid } });
    },
    async loadMoreFollower() {
      if (this.follower.hasMorePages && !this.follower.lazyLoading) {
        this.follower.lazyLoading = true;
        this.follower.page++;
        await this.getfollower();
        this.follower.lazyLoading = false;
      }
    },

    async loadMoreFollowing() {
      if (this.following.hasMorePages && !this.following.lazyLoading) {
        this.following.lazyLoading = true;
        this.following.page++;
        await this.getfollowing();
        this.following.lazyLoading = false;
      }
    },

    attachScrollEvent() {
      this.$nextTick(() => {
        let selector =
          this.selectedFollow === "follower"
            ? ".followerList .el-scrollbar__wrap"
            : ".followingList .el-scrollbar__wrap";

        const el = this.$el.querySelector(selector);
        if (el) {
          this.scrollEl = el;
          el.addEventListener("scroll", this.handleScroll);
          console.log("Scroll event attached to:", selector);
        } else {
          console.warn("Scroll element not found:", selector);
          // تلاش مجدد بعد از 500 میلی‌ثانیه
          setTimeout(() => {
            const retryEl = this.$el.querySelector(selector);
            if (retryEl) {
              this.scrollEl = retryEl;
              retryEl.addEventListener("scroll", this.handleScroll);
              console.log("Scroll event attached on retry to:", selector);
            }
          }, 500);
        }
      });
    },

    detachScrollEvent() {
      if (this.scrollEl) {
        this.scrollEl.removeEventListener("scroll", this.handleScroll);
        this.scrollEl = null;
      }
    },
    getfollower: function () {
      let self = this;
      // فقط برای صفحه اول loading رو true کن
      if (self.follower.page === 1) {
        this.follower.loading = true;
      }
      self.follower.hasMorePages = false;

      let userid = null;
      if (this.mode == "user") {
        userid = this.$router.currentRoute._value.query.uid;
      } else if (this.mode == "amlak") {
        userid = this.info_list.uid;
      }

      this.helperPost("followers-list", {
        page: self.follower.page,
        uid: userid,
      })
        .then(function (r) {
          const result = r.data;
          if (result.result === "1") {
            const list = result.data.list;
            const totalPage = parseInt(result.data.total_page);
            const currentPage = parseInt(self.follower.page);
            if (currentPage > 1) {
              // برای صفحات بعدی، لیست رو به انتهای لیست موجود اضافه کن
              self.follower.list = [...self.follower.list, ...list];
            } else {
              // فقط برای صفحه اول، لیست رو جایگزین کن
              const scrollbar = document.querySelector(
                ".followerList .el-scrollbar__wrap"
              );
              if (scrollbar) scrollbar.scrollTop = 0;

              self.follower.list = list;
            }

            self.follow_btn_loading = new Array(self.follower.list.length).fill(
              false
            );

            self.follower.hasMorePages = currentPage < totalPage;
          } else {
            self.follower.hasMorePages = false;
          }
          self.follower.loading = false;

          console.log("self.follower.list", self.follower.list);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          self.follower.loading = false;
          self.follower.hasMorePages = false;
        });
    },

    getfollowing: function () {
      let self = this;
      // فقط برای صفحه اول loading رو true کن
      if (self.following.page === 1) {
        this.following.loading = true;
      }
      self.following.hasMorePages = false;

      let userid = null;
      if (this.mode == "user") {
        userid = this.$router.currentRoute._value.query.uid;
      } else if (this.mode == "amlak") {
        userid = this.info_list.uid;
      }

      this.helperPost("following-list", {
        page: self.following.page,
        uid: userid,
      })
        .then(function (r) {
          const result = r.data;
          console.log("result", result);
          if (result.result === "1") {
            const list = result.data.list;
            const totalPage = parseInt(result.data.total_page);
            const currentPage = parseInt(self.following.page);
            console.log("ist0", list);
            if (currentPage > 1) {
              console.log("ist1", list);
              // برای صفحات بعدی، لیست رو به انتهای لیست موجود اضافه کن
              self.following.list = [...self.following.list, ...list];
            } else {
              // فقط برای صفحه اول، لیست رو جایگزین کن
              const scrollbar = document.querySelector(
                ".followingList .el-scrollbar__wrap"
              );
              if (scrollbar) scrollbar.scrollTop = 0;

              console.log("ist", list);
              self.following.list = list;
            }

            self.follow_btn_loading = new Array(
              self.following.list.length
            ).fill(false);

            self.following.hasMorePages = currentPage < totalPage;
          } else {
            self.following.hasMorePages = false;
          }
          self.following.loading = false;

          console.log("self.following.list", self.following.list);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          self.following.loading = false;
          self.following.hasMorePages = false;
        });
    },

    selectedFollowClose(btn = false) {
      let self = this;
      if (!this.isBackAction && btn) {
        history.back();
      }

      // پاک کردن event listener
      this.detachScrollEvent();

      setTimeout(() => {
        self.follower.list = [];
        self.following.list = [];
        self.selectedFollow = "";
      }, 500);
    },
    selectedFollowHandler(state, first = false) {
      if (!this.$store.state.auth.loggedIn) {
        toast("وارد حساب کاربری خود شوید", {
          type: "error",
        });
        return;
      }
      this.selectedFollow = state;
      if (first) {
        history.pushState(null, "", location.href);
      }
      // API فراخوانی رو حذف کردیم چون در watch انجام میشه
    },

    profileEditHadler() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        history.pushState(null, "", location.href);
      }
      this.ShowModel = true;
    },

    profileCloseHandler() {
      let windowWidth = window.innerWidth;
      if (windowWidth < 700) {
        history.back();
      }
      this.ShowModel = false;
    },

    handleBackBtn() {
      let windowWidth = window.innerWidth;
      if (this.ShowModel && windowWidth < 700) {
        this.ShowModel = false;
        return;
      }
      if (this.showEdit) {
        this.postId = 0;
        this.showEdit = false;
        return;
      } else {
        this.isBackAction = true;
        this.selectedFollowClose();
        this.isBackAction = false;
      }
    },
    clickOutSildeHandler() {
      if (this.showDeskOption) {
        this.showDeskOptionHandler();
      }
    },
    showDeskOptionHandler() {
      this.showDeskOption = !this.showDeskOption;
    },
    showLoginBox() {
      this.$refs.myBottomSheet.close();
      this.commentSheet = false;
      this.$nextTick(() => {
        this.ShowLoginBoxes = true;
      });
    },
    load_story(bid) {
      axios
        .get(this.$store.getters.baseUrl + "/get-story?branch_id=" + bid)
        .then((r) => {
          if (r.data.result == 0) {
            this.userStory = [];
          } else {
            this.userStory = r.data.data;
          }
        });
    },
    openDialog() {
      this.isDialogOpen = true;
      this.storyOpen = true;
      document.body.style.overflow = "hidden";
      history.pushState(null, "", location.href);
    },
    closeDialog() {
      if (!this.storyBackAction) {
        history.back();
      }
      this.isDialogOpen = false;
      this.storyOpen = false;
      document.body.style.overflow = "auto";
    },
    desktopMOdalHandler() {
      if (this.desktopCommentsModal) {
        this.desktopCommentsModal = false;
        document.body.style.overflow = "auto";
      } else {
        this.load_postComment("first");
        this.desktopCommentsModal = true;
        document.body.style.overflow = "hidden";
      }
    },
    replyToggleHandler(index) {
      if (this.showReply === index) {
        this.showReply = -1;
      } else {
        this.showReply = index;
      }
    },
    replyCommentHandler(index) {
      this.replyComment = index;
    },
    replyCommentCloseHandler() {
      this.replyComment = -1;
    },
    save_comment(parent_id = 0, from) {
      if (!this.$store.state.auth.loggedIn) {
        toast("برای ثبت نظر وارد حساب کاربری خود شوید", {
          type: "error",
        });
        return;
      }
      if (
        this.info_list &&
        this.info_list.uid &&
        this.$store.state.auth.loggedIn &&
        this.parent_id == 0
      ) {
        if (this.info_list.uid == this.$store.state.auth.uid) {
          this.newComment = "";
          toast("امکان ثبت نظر برای پروفایل خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      if (this.rate != 0 && this.info_list && this.info_list.myset_rate == 0) {
        this.saverate();
      }
      if (
        this.rate != 0 &&
        this.newComment == "" &&
        this.info_list &&
        this.info_list.myset_rate == 0
      ) {
        return;
      }
      if (this.newComment == "") {
        toast("نظر خود را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      let self = this;
      const formData = new FormData();

      formData.append("related_id", this.info_list.uid);
      formData.append("related_to", this.info_list.role);

      if (this.$store.state.auth.loggedIn)
        formData.append("author_id", this.$store.state.auth.uid);

      // تعیین parent_id برای ریپلای
      const actualParentId = from === "mob" ? this.parent_id : parent_id;

      if (actualParentId !== 0) {
        formData.append("parent_id", actualParentId);
        formData.append(
          "newComment",
          from === "mob" ? this.newComment : this.comment_replay[actualParentId]
        );
        self.comment_btn_replay_loading[actualParentId] = true;
      } else {
        formData.append("newComment", this.newComment);
        self.comment_btn_loading = true;
      }
      this.saverate();
      self.helperPost("save-comment", formData).then((r) => {
        if (r.data.result == "success") {
          // ساخت کامنت جدید
          // const newComment = {
          //   id: r.data.id || Date.now(),
          //   // name: self.$store.state.auth.name || "کاربر",
          //   name: this.userInforamtion.nickname,
          //   // avatar: self.$store.state.auth.avatar || "",
          //   avatar: this.userInforamtion.avatar,
          //   description:
          //     actualParentId !== 0
          //       ? from === "mob"
          //         ? this.newComment
          //         : this.comment_replay[actualParentId]
          //       : this.newComment,
          //   date: new Date().toLocaleDateString("fa-IR"),
          //   replay: [],
          // };

          if (actualParentId !== 0) {
            // افزودن پاسخ به کامنت مادر
            // const parentComment = self.CommentUserList.find(
            //   (comment) => comment.id === actualParentId
            // );
            // if (parentComment) {
            //   parentComment.replay.push(newComment);
            // }
            // پاک کردن فیلد ریپلای
            if (from === "mob") {
              self.newComment = "";
            } else {
              self.comment_replay[actualParentId] = "";
            }
          } else {
            self.newComment = "";
          }

          self.replyCommentCloseHandler();
          self.total += 1;

          toast(
            "نظر شما با موفقیت ثبت شد و پس از تأیید مدیریت نمایش داده خواهد شد.",
            {
              type: "success",
            }
          );
          self.parent_id = 0;
        } else {
          toast(r.data.msg, {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        self.comment_btn_replay_loading[actualParentId] = false;
        self.comment_btn_loading = false;
      });
    },

    // save_comment(parent_id = 0, from) {
    //   let self = this;
    //   const formData = new FormData();

    //   formData.append("related_id", this.info_list.uid);
    //   formData.append("related_to", this.info_list.role);

    //   if (this.$store.state.auth.loggedIn)
    //     formData.append("author_id", this.$store.state.auth.uid);

    //   if (parent_id) {
    //     formData.append("parent_id", parent_id);
    //     formData.append("newComment", this.comment_replay[parent_id]);
    //     self.comment_btn_replay_loading[parent_id] = true;
    //   } else {
    //     if (from == "mob") formData.append("parent_id", this.parent_id);
    //     formData.append("newComment", this.newComment);
    //     self.comment_btn_loading = true;
    //   }

    //   self.helperPost("save-comment", formData).then((r) => {
    //     if (r.data.result == "success") {
    //       self.newComment = "";
    //       this.replyCommentCloseHandler();
    //       toast(
    //         "نظر شما با موفقیت ثبت شد، بعداز تایید کارشناسان منتشر خواهد شد",
    //         {
    //           type: "success",
    //           dangerouslyHTMLString: true,
    //         }
    //       );
    //       this.parent_id = 0;
    //     } else {
    //       toast(r.data.msg, {
    //         type: "error",
    //         dangerouslyHTMLString: true,
    //       });
    //     }
    //     self.comment_btn_replay_loading[parent_id] = false;
    //     self.comment_btn_loading = false;
    //   });
    // },
    load_postComment(param) {
      let self = this;
      this.loadmore_comment = true;
      this.loadmore_loading_comment = true;
      this.page_comment += 1;
      if (param == "first") {
        this.isLoading_comment = true;
        this.CommentUserList = [];
        this.page_comment = 1;
      }
      this.helperGet(
        "get-comment",
        "related_to=" +
          this.info_list.role +
          "&related_id=" +
          this.info_list.uid +
          "&page=" +
          this.page_comment
      ).then((res) => {
        if (res.data.result === 1) {
          this.total_comment = res.data.data.total;
          // معکوس کردن ترتیب لیست کامنت‌ها
          const newComments = [...res.data.data.list].reverse();
          // اضافه کردن کامنت‌های جدید به انتهای لیست
          if (param === "first") {
            self.CommentUserList = newComments;
          } else {
            self.CommentUserList = self.CommentUserList.concat(newComments);
          }
          if (res.data.data.total_page == self.page_comment) {
            this.loadmore_comment = false;
          }
          // ایجاد وضعیت لودینگ برای هر کامنت
          self.comment_btn_replay_loading = [];
          self.CommentUserList.forEach(function (v) {
            self.comment_btn_replay_loading[v.id] = false;
          });
        }
        // this.loadmore_comment = false;
        this.isLoading_comment = false;
        this.loadmore_loading_comment = false;
      });
    },

    // load_postComment(param) {
    //   let self = this;
    //   this.loadmore_comment = true;
    //   this.loadmore_loading_comment = true;
    //   this.page_comment += 1;
    //   if (param == "first") {
    //     this.isLoading_comment = true;
    //     this.CommentUserList = [];
    //     this.page_comment = 1;
    //   }

    //   this.helperGet(
    //     "get-comment",
    //     "related_to=" +
    //       this.info_list.role +
    //       "&related_id=" +
    //       this.info_list.uid +
    //       "&page=" +
    //       this.page_comment
    //   ).then((res) => {
    //     if (res.data.result == 1) {
    //       this.total_comment = res.data.data.total;
    //       self.CommentUserList = self.CommentUserList.concat(
    //         res.data.data.list
    //       );
    //       if (res.data.data.total_page == self.page_comment) {
    //         this.loadmore_comment = false;
    //       }
    //       self.comment_btn_replay_loading = [];
    //       self.CommentUserList.forEach(function (v) {
    //         self.comment_btn_replay_loading[v.id] = false;
    //       });
    //     } else {
    //       self.CommentUserList = [];
    //     }

    //     this.isLoading_comment = false;
    //     this.loadmore_loading_comment = false;
    //   });
    // },
    send_edit_data() {
      if (this.user_info.fname == "") {
        toast("نام خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (this.user_info.lname == "") {
        toast("نام خانوادگی خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (this.user_info.code_melli == "") {
        toast("کد ملی خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (
        this.user_info.category_id == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("منطقه قعالیت خود را انتخاب کنید", {
          type: "error",
        });
        return;
      } else if (
        this.user_info.mobile == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("شماره تماس خود را وارد کنید", {
          type: "error",
        });
        return;
      } else if (
        this.user_info.address == "" &&
        this.$store.state.auth.role != "consultant"
      ) {
        toast("آدرس دفتر کار خود را وارد کنید", {
          type: "error",
        });
        return;
      }
      this.btn_loading = true;
      this.helperPost("update-profile", this.user_info).then((r) => {
        console.log("sdsd", r);
        if (r.data.result == "1") {
          toast(r.data.msg, {
            type: "success",
            dangerouslyHTMLString: true,
          });
          this.user_info_func("first");
          this.getCustomerinfo();
          this.ShowModel = false;
        } else {
          toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        this.btn_loading = false;
      });
    },
    showPost(post, index) {
      localStorage.removeItem("post_detail");
      this.$store.commit("post_detail_set", this.post_list[index]);
      this.$router.push(`/details/${post.id}`);
    },
    checkDocumentReady() {
      return new Promise((resolve) => {
        if (document.readyState === "complete") {
          resolve();
        } else {
          window.addEventListener("load", resolve, { once: true });
        }
      });
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    async previewImage(event) {
      var self = this;
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);

      new Compressor(file, {
        quality: 0.6,

        // The compression process is asynchronous,
        // which means you have to access the `result` in the `success` hook function.
        success(result) {
          const formData = new FormData();

          // The third parameter is required for server
          formData.append("avatar", result, result.name);
          formData.append("uid", self.$store.state.auth.uid);

          axios
            .post(self.$store.getters.baseUrl + "/upload-avatar", formData, {
              headers: {
                "Content-Type": "multipart/form-data", // Set the content type for file upload
                Authorization: "Bearer " + self.$store.getters.appToken,
              },
            })
            .then(function (response) {
              console.log("response", response);
              if (response.data.result == "1") {
                toast(response.data.msg, {
                  type: "success",
                  dangerouslyHTMLString: true,
                });
                self.user_info_func("first");
                self.ShowModel = false;
              } else {
                toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
                  type: "error",
                  dangerouslyHTMLString: true,
                });
              }
            });
        },
        error(err) {
          console.log(err.message);
        },
      });
    },
    removeImage() {
      var self = this;
      self.imageSrc = null;
      self.$refs.fileInput.value = "";
      self.$swal
        .fire({
          title: "حذف تصویر پروفایل",
          text: "آیا از حذف تصویر پروفایل مطمئن هستید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "بله مطمئنم",
          cancelButtonText: "لغو",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              self
                .helperGet("delete-avatar", "uid=" + this.$store.state.auth.uid)
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.imageSrc = null;
                    self.$refs.fileInput.value = "";
                    self.user_info_func("first");
                    self.ShowModel = false;
                  }
                });
            }
          }
        });
    },
    user_info_func(param) {
      let self = this;
      // this.LoadingSkeleton = true;
      self.mode = "user";
      const uid = this.$route.query.uid;
      var user_id = 0;
      var list_type = "public";

      if (this.$store.state.auth.loggedIn) {
        console.log("this.$store.state.auth.uid", this.$store.state.auth.uid);
        user_id = this.$store.state.auth.uid;
        if (user_id == uid) {
          list_type = "own_profile";
          this.myprofile = true;
        }
      }

      this.loadmore = true;
      this.loadmore_loading = true;
      this.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.page = 1;
      }

      this.helperGet(
        "user-infos",
        "uid=" +
          uid +
          "&user_id=" +
          user_id +
          "&page=" +
          this.page +
          "&list_type=" +
          list_type +
          "&post_type=" +
          this.postType
      ).then((res) => {
        self.info_list = res.data;
        console.log("info_list", res.data);
        res.data.has_avatar ? (this.imageSrc = res.data.avatar) : "";

        self.user_info = {
          avatar: res.data.avatar,
          uid: res.data.uid,
          role: res.data.role,
          fname: res.data.fname,
          lname: res.data.lname,
          company_name: res.data.company_name,
          mobile: res.data.mobile,
          code_melli: res.data.code_melli,
          address: res.data.address,
          work_history: res.data.work_history,
          phone: res.data.phone,
          telegram: res.data.telegram,
          insta: res.data.instagram,
          whats_app: res.data.whatsup,
          description: res.data.description,
          category_id: (res.data.category_id || []).map((id) => Number(id)),
          b_activity_type: res.data.b_activity_type || [],
        };

        self.completeInfos = res.data;

        self.rate = res.data.myset_rate;
        self.rateNum = res.data.user_rate;

        if (res.data.posts.list && res.data.posts.list.length > 0) {
          self.post_list = self.post_list.concat(res.data.posts.list);
          console.log(res.data.posts.list);
          if (res.data.posts.total_page == self.page) {
            this.loadmore = false;
          }
        } else {
          this.loadmore = false;
        }

        this.isLoading = false;
        this.loadmore_loading = false;
        this.LoadingSkeleton = false;
        this.filterLoading = false;
      });
    },

    amlak_info(param) {
      let self = this;
      self.mode = "amlak";
      const bid = this.$router.currentRoute._value.query.bid;
      var user_id = 0;
      var list_type = "public";

      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
      }

      this.loadmore = true;
      this.loadmore_loading = true;
      this.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.page = 1;
      }

      this.helperGet(
        "user-infos",
        "branch_id=" +
          bid +
          "&user_id=" +
          user_id +
          "&page=" +
          this.page +
          "&list_type=" +
          list_type
      ).then((res) => {
        self.info_list = res.data;
        console.log("info_list", res.data);
        if (res.data.posts.list && res.data.posts.list.length > 0) {
          self.post_list = self.post_list.concat(res.data.posts.list);
          console.log(res.data.posts.list);
          if (res.data.posts.total_page == self.page) {
            this.loadmore = false;
          }
        } else {
          this.loadmore = false;
        }

        this.isLoading = false;
        this.loadmore_loading = false;
        this.LoadingSkeleton = false;
        self.rate = res.data.myset_rate;
        self.rateNum = res.data.user_rate;
        // console.log("self.post_list", self.post_list);
      });
    },
    Logout() {
      this.$swal
        .fire({
          title: "خروج از حساب کاربری",
          text: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "خروج",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("logout")
                .then((r) => {
                  if (r.data.success == true) {
                    this.$store.state._token = "";
                    this.$store.getters.auth.loggedIn = false;
                    // this.$store.state.c_set = [];
                    localStorage.removeItem("_token");
                    localStorage.removeItem("auth");
                    this.$router.push({ path: "/home" });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          } else {
            this.$swal.close();
          }
        });
    },
    follow(target_id) {
      var user_id = 0;
      if (this.$store.state.auth.loggedIn) {
        this.loadingFollow = true;
        if (target_id) {
          user_id = this.$store.state.auth.uid;
          this.helperPost("follow", {
            uid: user_id,
            target_id: target_id,
          }).then((r) => {
            this.info_list.is_follow = r.data.result;
            this.loadingFollow = false;
            if (this.mode == "user") {
              this.user_info_func();
            } else if (this.mode == "amlak") {
              this.amlak_info();
            }
          });
        }
      } else {
        this.ShowLoginBoxes = true;
        this.$store.state.login_modal = true;
      }
    },

    saverate() {
      var user_id = 0;
      if (this.$store.state.auth.loggedIn) {
        this.loadingRate = true;
        if (this.info_list.uid) {
          user_id = this.$store.state.auth.uid;
          this.helperPost("save-rate", {
            uid: user_id,
            target_id: this.info_list.uid,
            rate: this.rate,
          }).then((r) => {
            this.loadingRate = false;
            if (r.data.result == "1") this.rateNum = r.data.avg;
          });
        }
      } else {
        this.ShowLoginBoxes = true;
        this.$store.state.login_modal = true;
      }
    },
    OpenMessage() {
      this.commentSheet = true;
      this.$nextTick(() => {
        this.$refs.myBottomSheet.open();
        this.load_postComment("first");
      });
    },
    handleWindowScroll() {
      let windowSize = window.innerWidth;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      if (windowSize > 1000) {
        if (scrollTop + windowHeight + 686.6 >= fullHeight) {
          if (this.loadmore && !this.loadmore_loading) {
            if (this.mode == "user") {
              this.user_info_func();
            } else if (this.mode == "amlak") {
              this.amlak_info();
            }
          }
        }
      } else {
        if (scrollTop + windowHeight + 100 >= fullHeight) {
          if (this.loadmore && !this.loadmore_loading) {
            console.log("loadingMore", this.loadmore);
            if (this.mode == "user") {
              this.user_info_func();
            } else if (this.mode == "amlak") {
              this.amlak_info();
            }
          }
        }
      }
    },
    reloadProfileData(path) {
      this.info_list = [];
      this.post_list = [];
      this.userStory = [];
      this.LoadingSkeleton = true;
      this.selectedFollow = '';

      setTimeout(() => {
        if (path === "/profile-amlak") {
          this.amlak_info("first");
        } else {
          this.user_info_func("first");
        }
        const bid = this.$route.query.bid;
        if (bid) {
          this.load_story(bid);
          console.log("bid", bid);
        }
      }, 2000);
    },

    handleScrollComment() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      // لیزی لود: اگر ۱۰۰ پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore_comment && !this.loadmore_loading_comment) {
          this.load_postComment(); // متد لود داده‌هات
        }
      }

      // تغییر وضعیت یک div (مثلاً موقعیت فیلتر بالای صفحه)
      if (scrollTop > 100) {
        this.divTop = "top:20px; width:85%;margin: 0;right: 5%";
      } else {
        this.divTop = "top:80px; width:90%;margin: auto";
      }
    },
    postCommentLoadHandler(param) {
      let self = this;
      this.commentsLoadeMore = true;
      this.commentsLoademoreLoading = true;
      // افزایش صفحه‌بندی بخش کامنت‌های پست (نباید از this.page استفاده شود)
      this.Commentpage += 1;
      if (param == "first") {
        this.commentsLoading = true;
        this.postCommentsList = [];
        this.Commentpage = 1;
      }

      this.helperGet(
        "get-comment",
        "related_to=post" +
          "&related_id=" +
          this.post_list?.[this.postIndex]?.id +
          "&page=" +
          this.Commentpage
      ).then((res) => {
        if (res.data.result == 1) {
          this.total = res.data.data.total;
          // اضافه کردن کامنت‌های جدید به انتهای لیست
          const newComments = [...res.data.data.list].reverse(); // معکوس کردن ترتیب کامنت‌ها
          self.postCommentsList = self.postCommentsList.concat(newComments);

          if (res.data.data.total_page == self.Commentpage) {
            this.commentsLoadeMore = false;
          }
          self.postComment_btn_replay_loading = [];
          self.postCommentsList.forEach(function (v) {
            self.postComment_btn_replay_loading[v.id] = false;
          });
        }

        this.commentsLoading = false;
        this.commentsLoademoreLoading = false;
      });
    },
    postCommentsSaveHandler(parent_id = 0, from) {
      if (!this.$store.state.auth.loggedIn) {
        toast("برای ثبت نظر وارد حساب کاربری خود شوید", {
          type: "error",
        });
        return;
      }
      if (
        this.post_datail &&
        this.post_datail.user_id &&
        this.$store.state.auth.loggedIn &&
        this.parent_id == 0
      ) {
        if (this.post_datail.user_id == this.$store.state.auth.uid) {
          this.newComment = "";
          toast(`امکان ثبت نظر برای پروژه‌های متعلق به خودتان وجود ندارد.`, {
            type: "error",
          });
          return;
        }
      }
      let self = this;
      const formData = new FormData();

      formData.append("related_id", this.post_list?.[this.postIndex]?.id);
      formData.append("related_to", "post");

      if (this.$store.state.auth.loggedIn)
        formData.append("author_id", this.$store.state.auth.uid);

      // تعیین parent_id برای ریپلای
      const actualParentId = from === "mob" ? this.postParent_id : parent_id;

      if (actualParentId !== 0) {
        formData.append("parent_id", actualParentId);
        formData.append(
          "newComment",
          from === "mob"
            ? this.postNewComment
            : this.post_comment_replay[actualParentId]
        );
        self.postComment_btn_replay_loading[actualParentId] = true;
      } else {
        formData.append("newComment", this.postNewComment);
        self.post_comment_btn_loading = true;
      }

      self.helperPost("save-comment", formData).then((r) => {
        if (r.data.result == "success") {
          // Create new comment object
          // const newComment = {
          //   id: r.data.id || Date.now(),
          //   name: self.$store.state.auth.name || "کاربر",
          //   avatar: self.$store.state.auth.avatar || "",
          //   description:
          //     actualParentId !== 0
          //       ? from === "mob"
          //         ? this.postNewComment
          //         : this.post_comment_replay[actualParentId]
          //       : this.postNewComment,
          //   date: new Date().toLocaleDateString("fa-IR"),
          //   replay: [],
          // };

          if (actualParentId !== 0) {
            // Add reply to parent comment
            // const parentComment = self.postCommentsList.find(
            //   (comment) => comment.id === actualParentId
            // );
            // if (parentComment) {
            //   parentComment.replay.push(newComment);
            // }
            if (from === "mob") {
              self.postNewComment = "";
            } else {
              self.post_comment_replay[actualParentId] = "";
            }
          } else {
            // Add new comment to end of list
            // self.postCommentsList.push(newComment);
            self.postNewComment = "";
          }

          self.postreplyCommentCloseHandler();
          self.total += 1;

          toast(
            "نظر شما با موفقیت ثبت شد و پس از تأیید مدیریت نمایش داده خواهد شد.",
            {
              type: "success",
            }
          );
          self.postParent_id = 0;
        } else {
          toast(r.data.msg, {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        self.postComment_btn_replay_loading[actualParentId] = false;
        self.post_comment_btn_loading = false;
      });
    },
    postreplyCommentCloseHandler() {
      this.postreplyComment = -1;
    },
    postreplyCommentHandler(index) {
      this.postreplyComment = index;
    },
    post_replay_focuse(parent_id = 0) {
      this.postParent_id = parent_id;
      if (document.getElementById("postComment")) {
        document.getElementById("postComment").focus();
      }
      if (document.getElementById("newComment_mob")) {
        document.getElementById("newComment_mob").focus();
      }
    },
    save_like(post_id) {
      var user_id = 0;
      if (!this.$store.state.auth.loggedIn) {
        toast("برای لایک کردن آگهی وارد حساب کاربری خود شوید.", {
          type: "error",
        });
        return;
      }
      if (
        this.post_datail &&
        this.post_datail.user_id &&
        this.$store.state.auth.loggedIn
      ) {
        if (this.post_datail.user_id == this.$store.state.auth.uid) {
          toast("امکان لایک کردن آگهی‌های متعلق به خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        this.helperGet(
          "save-like",
          "post_id=" + post_id + "&user_id=" + user_id
        ).then((r) => {
          this.post_list[this.postIndex].is_like = r.data.result;
          if (r.data.result == 1) this.post_list[this.postIndex].likes -= 1;

          if (r.data.result == 2) this.post_list[this.postIndex].likes += 1;
        });
      } else {
        this.ShowLoginBoxes = true;
      }
    },
    // save_favorit(post_id) {
    //   var user_id = 0;
    //   if (this.$store.state.auth.loggedIn) {
    //     user_id = this.$store.state.auth.uid;
    //     this.helperGet(
    //       "save-favorite",
    //       "post_id=" + post_id + "&user_id=" + user_id
    //     ).then((r) => {
    //       this.post_list[this.postIndex].is_favorite = r.data.result;
    //     });
    //   } else {
    //     this.ShowLoginBoxes = true;
    //   }
    // },
    setupScrollListener() {
      const scrollElement = this.$refs.contentMain;
      if (!scrollElement) return;

      scrollElement.addEventListener("scroll", this.handlePostCommentScroll);
    },
    handlePostCommentScroll() {
      const scrollElement = this.$refs.contentMain;
      if (!scrollElement) return;

      const scrollTop = scrollElement.scrollTop;
      const scrollHeight = scrollElement.scrollHeight;
      const clientHeight = scrollElement.clientHeight;
      // اگر 100 پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.commentsLoadeMore && !this.commentsLoademoreLoading) {
          this.postCommentLoadHandler(); // متد مورد نظر شما برای لود بیشتر
        }
      }
    },
    del_post(id) {
      let self = this;
      this.$swal
        .fire({
          title: "پروژه حذف گردد؟",
          text: "پس از این عملیات پروژه برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              this.helperPost("del-post", { post_id: id })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    this.showDetails = false;
                    setTimeout(() => {
                      self.user_info_func("first");
                    }, 500);
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    del_file(id) {
      let self = this;
      this.$swal
        .fire({
          title: "آگهی حذف گردد؟",
          text: "پس از این عملیات آگهی برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              this.helperPost("del-post", { post_id: id })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    this.showDetails = false;
                    setTimeout(() => {
                      self.user_info_func("first");
                    }, 500);
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    editPostHandler(id) {
      if (id) {
        this.$router.push(`/builder-create-post/${id}`);
      }
    },
    async shareContent(pid) {
      const routeUId = this.$route.query.uid;
      const routeId = this.$store.state.auth.uid;
      if (this.$store.state.device == "Desktop") {
        const textToCopy = `${window.origin}/builder-post-details/${routeUId}/${pid}`;
        const shareUrl = document.createElement("textarea");
        shareUrl.value = textToCopy;
        document.body.appendChild(shareUrl);

        shareUrl.select();
        document.execCommand("copy");
        document.body.removeChild(shareUrl);

        toast("متن اشتراک گذاری کپی شد.", {
          type: "success",
          dangerouslyHTMLString: true,
        });
      } else {
        try {
          await Share.share({
            title: this.title,
            text: this.text,
            url: `shomalamlak.ir/builder-details/${routeUId}/${routeId}`,
            dialogTitle: "شمال املاک",
          });
        } catch (error) {
          console.error("خطا در اشتراک‌گذاری:", error);
        }
      }
    },
    replay_blur() {
      this.parent_id = 0;
      this.newComment = "";
      if (document.getElementById("newComment_mob")) {
        document.getElementById("newComment_mob").blur();
      }
      if (document.getElementById("postComment")) {
        document.getElementById("postComment").blur();
      }
    },
    load_district() {
      let self = this;
      this.helperGet("system-cat", "type=branch").then((r) => {
        console.log("datattt:" + r.data.data);
        self.district_list = r.data.data;
      });
    },
    handleCheckboxChange(event, type) {
      if (event.target.checked) {
        if (!this.user_info.b_activity_type.includes(type)) {
          this.user_info.b_activity_type = [
            ...this.user_info.b_activity_type,
            type,
          ];
        }
      } else {
        this.user_info.b_activity_type = this.user_info.b_activity_type.filter(
          (e) => e !== type
        );
      }
      console.log(
        "this.user_info.b_activity_type",
        this.user_info.b_activity_type
      );
    },
    getJalaliYears() {
      const faYear = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
      }).format(new Date());

      const enYear = this.convertPersianToEnglish(faYear);

      for (let i = +enYear; i >= 1370; i--) {
        this.years.push(i.toString());
      }
    },
    convertPersianToEnglish(str) {
      const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

      return str
        .split("")
        .map((ch) => {
          const index = persianNumbers.indexOf(ch);
          return index > -1 ? englishNumbers[index] : ch;
        })
        .join("");
    },
  },

  async mounted() {
    this.getJalaliYears();
    if (
      this.$store.state.auth.loggedIn &&
      this.$route.params.uid == this.$store.state.auth.uid
    ) {
      if (!this.$store.state.auth.is_complate) {
        toast("لطفا اطلاعات پروفایل خود را تکمیل کنید", {
          type: "warning",
        });
      }
    }
    // this.reloadPage();
    // setTimeout(() => {
    //   this.user_info('first');
    //
    // }, 2000);
    this.load_district();
    this.getPostHandler();
    console.log("infoList", this.info_list);
    console.log("route_id", this.$router.currentRoute._value.query.uid);
    this.handleFollowHeight();
    this.editStyleHandler();
    console.log("auth", this.$store.state.auth);
    window.addEventListener("popstate", this.handleBackBtn);
    window.addEventListener("resize", function () {
      this.editStyleHandler;
      this.handleFollowHeight;
    });
    window.addEventListener("scroll", this.handleWindowScroll);
    this.userInforamtion = JSON.parse(localStorage.getItem("auth"));
    document.body.addEventListener("click", this.clickOutSildeHandler);
    // const bid = this.$route.query.bid;
    // if (bid) {
    //   this.load_story(bid);
    // }
    await nextTick();
    // this.loadMoreTrigger = this.$refs.loadMoreTrigger;
    this.loadMoreTrigger2 = this.$refs.loadMoreTrigger2;
    // const observer = new IntersectionObserver(
    //   ([entry]) => {
    //     if (entry.isIntersecting) {
    //       if (this.mode == "user") {
    //         this.user_info_func();
    //       } else if (this.mode == "amlak") {
    //         this.amlak_info();
    //       }
    //     }
    //   },
    //   { threshold: 1.0 }
    // );
    const observer2 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // this.load_postComment();
        }
      },
      { threshold: 1.0 }
    );
    // if (this.loadMoreTrigger) {
    //   observer.observe(this.loadMoreTrigger);
    // }
    if (this.loadMoreTrigger2) {
      observer2.observe(this.loadMoreTrigger2);
    }
  },

  beforeUnmount() {
    window.removeEventListener("popstate", this.handleBackBtn);
    window.removeEventListener("scroll", this.handleWindowScroll);
  },

  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const path = route.path;
        const query = route.query;

        // شرط فراخوانی، هر وقت آدرس یا uid یا bid عوض شد
        if (
          path === "/profile-amlak" ||
          path === "/profile-superior" ||
          path === "/profile-builder" ||
          path === "/profile-personal"
        ) {
          if (query.uid || query.bid) {
            this.reloadProfileData(path);
          }
        }
      },
    },
    // "$route.path": {
    //   immediate: true,
    //   handler(value) {
    //     this.info_list = [];
    //     this.post_list = [];
    //     this.LoadingSkeleton = true;
    //     if (value == "/profile-amlak") {
    //       setTimeout(() => {
    //         this.amlak_info("first");
    //       }, 2000);
    //     } else if (
    //       value == "/profile-superior" ||
    //       value == "/profile-personal"
    //     ) {
    //       setTimeout(() => {
    //         this.user_info_func("first");
    //       }, 2000);
    //     }
    //   },
    // },
    // "$route.query": {
    //   immediate: true,
    //   handler(query) {
    //     if (query.uid || query.bid) {
    //       this.info_list = [];
    //       this.post_list = [];
    //       this.LoadingSkeleton = true;

    //       const path = this.$route.path;

    //       if (path === "/profile-amlak") {
    //         setTimeout(() => {
    //           this.amlak_info("first");
    //         }, 2000);
    //       } else if (
    //         path === "/profile-superior" ||
    //         path === "/profile-personal"
    //       ) {
    //         setTimeout(() => {
    //           this.user_info_func("first");
    //         }, 2000);
    //       }
    //     }
    //   },
    // },
    showFollowed(val) {
      if (val) {
        this.attachScrollEvent();
      } else {
        this.detachScrollEvent();
      }
    },

    selectedFollow(val) {
      // وقتی تب عوض میشه، صفحه‌بندی رو reset کن و داده‌ها رو لود کن
      if (val === "follower") {
        this.follower.page = 1; // ریست کردن صفحه برای followers
        this.follower.list = []; // پاک کردن لیست قبلی
        this.follower.hasMorePages = true; // reset کردن hasMorePages
        this.getfollower(); // لود کردن داده‌ها
      } else if (val === "following") {
        this.following.page = 1; // ریست کردن صفحه برای following
        this.following.list = []; // پاک کردن لیست قبلی
        this.following.hasMorePages = true; // reset کردن hasMorePages
        this.getfollowing(); // لود کردن داده‌ها
      }

      this.detachScrollEvent();
      this.attachScrollEvent();
    },
  },
};
</script>

<style scoped lang="scss">
.skeleton-box {
  display: block;
  background: rgb(146, 221, 238);
}
.dark {
  .profileHeader {
    .headerContainer {
      .containerHeader {
        .headerDetails {
          .deatislTitle {
            span {
              color: #fff;
            }
          }
          .detailsBrand {
            color: #ededed;
          }
          .detailsRole {
            color: #dedede;
          }

          .detailsRate {
            & > div {
              color: #dedede;

              span {
                color: #fff;
              }
            }
          }
        }
      }
      .containerMain {
        .mainStatistics {
          .statisticsWrapper {
            .statisticsThumb {
              .thumbValue {
                color: #fff;
              }
              .thumbTitle {
                color: #dedede;
              }
            }
          }
        }
        .mainOptions {
          .optionsThumb {
            &.rateThumb {
              color: #fff;
              border-color: #ff7b00;
              background: #ff7b00;
            }
          }
        }
      }
      .containerFooter {
        .footerSection {
          .sectionHeader {
            color: #fff;
          }
          &.bioSection {
            .sectionMain {
              color: #dedede;
            }
          }

          &.exprtiseSection {
            .sectionMain {
              .exprtiseThumb {
                background: rgb(51, 54, 57);
              }
            }
          }
          &.contactSection {
            .sectionMain {
              .contactThumb {
                color: #dedede;
              }
            }
          }
        }
      }
    }
  }
}

.profileHeader {
  padding: 24px 0 16px;
  margin-bottom: 0;

  .headerContainer {
    position: relative;
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .containerHeader {
      margin-bottom: 16px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: row-reverse;
      gap: 16px;

      .headerDetails {
        flex-grow: 1;
        display: block;
        .deatislTitle {
          display: flex;
          align-items: center;
          gap: 8px;

          .titleSk {
            width: 192px;
            height: 36px;
            border-radius: 9999px;
          }

          span {
            font-family: "iranyekanB", sans-serif;
            font-size: 1.5rem;
            line-height: 2rem;
            margin-bottom: 4px;
            color: rgb(31 41 55);
          }
        }
        .detailsBrand {
          color: rgb(75 85 99);
          margin-bottom: 4px;
          font-size: 1rem;
          line-height: 1.25rem;

          .brandSk {
            width: 142px;
            height: 20px;
            border-radius: 9999px;
          }
        }

        .detailsRole {
          color: rgb(107 114 128);
          margin-bottom: 4px;
          font-size: 0.975rem;
          line-height: 1.25rem;

          .roleSk {
            width: 124px;
            height: 20px;
            border-radius: 9999px;
          }
        }

        .detailsRate {
          display: flex;
          align-items: center;
          gap: 4px;

          & > div {
            font-size: 0.925rem;
            color: rgb(107 114 128);
            line-height: 1.25rem;

            span {
              font-size: 1.25rem;
              line-height: 1.75rem;
              color: rgb(31 41 55);
              font-weight: 600;
            }
          }

          :deep(.el-rate) {
            height: auto !important;
            margin-top: -3px;

            .el-rate__item {
              color: #d5d5d5 !important;

              &:not(:first-child) {
                .el-icon {
                  margin-right: 2px !important;
                }
              }

              .el-icon {
                width: 22px;
                height: 22px;
                &.is-active {
                  color: rgb(250 204 21) !important;
                }

                svg {
                  width: 22px;
                  height: 22px;
                }
              }
            }
          }
        }
      }
      .headerProfile {
        flex-shrink: 0;
        /* padding-left: 24px; */

        .profilePic {
          position: relative;
          width: 124px;
          height: 124px;
          border-radius: 50%;
          padding: 3px;
          background: linear-gradient(
            45deg,
            #feda75,
            #fa7e1e,
            #d62976,
            #962fbf,
            #4f5bd5
          );
          display: flex;
          align-items: center;
          justify-content: center;

          .storyToggler {
            position: absolute;
            inset: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            border-radius: 9999px;
          }

          .profileSk {
            width: 100%;
            height: 100%;
            border-radius: 9998px;
          }

          &.noStory {
            background: transparent;
          }

          img {
            width: 120px;
            height: 120px;
            border-radius: 9999px;
            object-fit: cover;
            object-position: center;
          }
        }
      }
    }

    .containerMain {
      max-width: 472px;
      .mainStatistics {
        margin-bottom: 24px;

        .statisticsWrapper {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 1rem;

          .statisticsThumb {
            text-align: center;

            .thumbSk {
              width: 58px;
              height: 58px;
              margin-left: auto;
              margin-right: auto;
              border-radius: 8px;
            }

            .thumbValue {
              font-size: 1.5rem;
              line-height: 2rem;
              font-family: "iranyekanB", sans-serif;
              color: rgb(31 41 55);
            }
            .thumbTitle {
              font-size: 0.875rem;
              line-height: 1.25rem;
              color: rgb(107 114 128);
            }
          }
        }
      }
      .mainOptions {
        position: absolute;
        left: 0;
        top: 0;
        margin-bottom: 24px;
        display: grid;
        grid-template-columns: 100%;
        width: 284px;
        gap: 0.75rem;

        &.userCustomer {
          grid-template-columns: 100%;
        }

        .thumbSk {
          width: 100%;
          height: 46px;
          border-radius: 12px;
        }

        .optionsThumb {
          width: 100%;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #fff;
          border-radius: 12px;
          font-size: 1rem;
          gap: 8px;

          &.followBtn {
            background: #0096c7;
            color: #fff;
            border-color: #0096c7;
          }

          &.unfollowBtn {
            background: #ef4444;
            color: #fff;
            border-color: #ef4444;
          }

          &.rateThumb {
            color: #fff;
            border-color: #ff7b00;
            background: #ff7b00;

            .commentCount {
              width: 24px;
              height: 24px;
              border-radius: 9999px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ff7b00;
              font-size: 0.875rem;
              background: #fff;
              font-family: "iranyekanB", sans-serif;
            }
          }
        }
      }
    }
    .containerFooter {
      display: block;
      display: grid;
      grid-template-columns: 1fr 1fr;

      .footerSk {
        width: 100%;
        height: 18px;
        border-radius: 9999px;
        margin-bottom: 6px;
        grid-column: span 2;
      }

      .footerSection {
        &:not(:last-child) {
          margin-bottom: 16px;
        }

        .sectionHeader {
          color: rgb(31 41 55);
          font-weight: 600;
          font-size: 1rem;
          line-height: 1.25rem;
          margin-bottom: 12px;
        }

        &.bioSection {
          grid-column: span 2;
          .sectionMain {
            line-height: 1.625;
            color: rgb(55 65 81);
            font-size: 0.915rem;
          }
        }

        &.exprtiseSection {
          .sectionMain {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;

            .exprtiseThumb {
              padding: 4px 12px;
              background: rgb(239 246 255);
              color: #0096c7;
              font-size: 0.75rem;
              line-height: 1rem;
              border-radius: 9999px;
            }
          }
        }

        &.contactSection {
          .sectionMain {
            .contactThumb {
              display: flex;
              align-items: center;
              gap: 8px;
              color: rgb(75 85 99);
              font-size: 0.915rem;
              line-height: 1.25rem;

              &.userMobile {
                color: #0096c7;

                span {
                  text-decoration: underline;
                }
              }

              &:not(:first-child) {
                margin-top: 8px;
              }
            }
          }
        }

        &.mediaSection {
          .sectionMain {
            display: flex;
            align-items: center;
            gap: 16px;

            .mediaThumb {
              color: rgb(75 85 99);
              font-size: 1.75rem;
              line-height: 1.75rem;

              &.telegram {
                color: #0088cc;
              }

              &.instagram {
                background: linear-gradient(
                  45deg,
                  #feda75,
                  #fa7e1e,
                  #d62976,
                  #962fbf,
                  #4f5bd5
                );
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }

              &.whatsapp {
                color: #25d366;
              }
            }
          }
        }
      }
    }
  }
}

.dark {
  .profileBuilder {
    .mainHeader {
      .headerWrapper {
        .wrapperThumb {
          color: #fff;
        }
      }
    }
    .profileBuilderMain {
      .mainContainer {
        .containerList {
          .listThumb {
            box-shadow: 0 4px 6px -1px rgba(255, 255, 255, 0.1),
              0 2px 4px -2px rgba(255, 255, 255, 0.1);
            background: #101a23;

            .thumbContent {
              .contentTitleWrapper {
                .contentTitle {
                  color: #fff;
                }
                .contentStatus {
                  background: #232323;
                }
              }
              .contentDesc {
                color: rgb(185, 202, 225);
              }
            }
          }
        }
      }
    }
  }
}

.profileBuilder {
  .mainHeader {
    width: 100%;
    margin-bottom: 32px;

    .headerWrapper {
      width: 90%;
      margin-left: auto;
      margin-right: auto;
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: 24px;
      border-bottom: 1px solid rgb(229 231 235);

      .wrapperThumb {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 0.875rem;
        line-height: 1.25rem;
        padding: 1rem 0.25rem;
        border-bottom: 2px solid transparent;
        cursor: pointer;

        &.active {
          color: #0096c7;
          border-bottom: 2px solid #0096c7;
        }
      }
    }
  }
  .profileBuilderMain {
    width: 100%;
    padding: 0 0 54px;

    .mainContainer {
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .containerList {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 24px;

        .listThumb {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          position: relative;
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
            0 2px 4px -2px rgb(0 0 0 / 0.1);
          background: #fff;
          border-radius: 12px;

          .thumbPic {
            width: 100%;
            height: 192px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: center;
            }
          }

          .thumbContent {
            padding: 24px;

            .contentTitleWrapper {
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 16px;
              margin-bottom: 8px;
            }
            .contentStatus {
              width: fit-content;
              padding: 4px 8px;
              border-radius: 24px;
              background: #f7f7f7;
              font-size: 0.8rem;
              color: #0096c7;
              flex-shrink: 0;
            }

            .contentTitle {
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
              font-size: 1.125rem;
              line-height: 1.75rem;
              font-family: "iranyekanB", sans-serif;
              flex-grow: 1;
              text-overflow: ellipsis;
            }

            .contentDesc {
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              height: 60px;
              color: rgb(75 85 99);
              font-size: 0.875rem;
              line-height: 1.25rem;
              margin-bottom: 16px;
            }

            .contentDetails {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .detailsRate {
                display: flex;
                align-items: center;
                gap: 16px;

                .rateThumb {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 4px;
                  color: rgb(75, 85, 99);
                  font-size: 0.875rem;
                  line-height: 1.25rem;
                }
              }
              .detailsDate {
                .dateThumb {
                  color: rgb(156 163 175);
                  font-size: 0.75rem;
                  line-height: 1rem;
                }
              }
            }
          }
        }
      }
    }
  }
}

:deep(.el-overlay.profileDetails) {
  .el-dialog {
    padding: 0;
    width: 90%;
    max-width: 1024px;
    height: 90vh;
    border-radius: 8px !important;
    position: relative;

    .el-dialog__body {
      height: 100%;
    }

    .el-dialog__header {
      display: none;
    }

    .changePostBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      cursor: pointer;
      border-radius: 50%;
      color: #000;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
      transition: all 0.1s;

      &:active {
        transform: translateY(-50%) scale(0.95);
      }

      svg {
        width: 28px;
        height: 28px;
      }

      &.PrevBtn {
        right: -8%;
      }

      &.NextBtn {
        left: -8%;
      }
    }

    .detailsContainer {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 4px;

      .containerList {
        width: 100%;
        height: 100%;

        .listThumb {
          width: 100%;
          height: 100%;
          display: flex;

          .thumbPic {
            width: 60%;
            height: 100%;
            flex-shrink: 0;
            background: #f9fafb;
            border-bottom-right-radius: 8px !important;
            border-top-right-radius: 8px !important;
            overflow: hidden;

            .swiper {
              height: 100% !important;
            }

            .swiper-button-next,
            .swiper-button-prev {
              width: 36px;
              height: 36px;
              background: rgba(0, 0, 0, 0.4);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 20px;
              color: #fff !important;

              &::after {
                font-size: 20px !important;
                font-weight: 700 !important;
                position: absolute !important;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .thumbContent {
            position: relative;
            width: 40%;
            height: 100%;
            overflow: hidden;
            padding-top: 74px;

            .contentHeader {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              z-index: 99;
              background: #fff;
              padding: 16px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-top-left-radius: 8px !important;
              border-bottom: 1px solid rgb(229 231 235);

              .headerContent {
                display: flex;
                align-items: center;
                gap: 12px;

                .contentPic {
                  width: 42px;
                  height: 42px;
                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                  }
                }

                .contentInfo {
                  font-family: "iranyekanB", sans-serif;
                  font-size: 1rem;
                  color: #000;
                }
              }

              .headerOptions {
                display: flex;
                align-items: center;
                gap: 8px;
                .optionFollow {
                  height: 32px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 0.85rem;
                  color: #fff;
                  background: #0096c7;
                  border-radius: 9999px;
                  padding: 0 16px;
                }
                .optionUnFollow {
                  height: 32px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 0.85rem;
                  color: #0096c7;
                  border: 2px solid #0096c7;
                  background: #fff;
                  border-radius: 9999px;
                  padding: 0 16px;
                }

                .optionEditBtn {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  font-size: 0.925rem;
                  color: #fff;
                  width: 32px;
                  height: 32px;
                  border-radius: 6px;
                  background: #0096c7;
                }

                .optionDelete {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  font-size: 0.925rem;
                  color: #fff;
                  width: 32px;
                  height: 32px;
                  border-radius: 6px;
                  background: #f00;
                }
              }
            }

            .contentMain {
              width: 100%;
              height: calc(100% - 56.8px);
              overflow-x: hidden;
              overflow-y: auto;
              padding: 16px;

              .mianHeader {
                padding-bottom: 16px;
                border-bottom: 1px solid rgb(243 244 246);

                .headerStatus {
                  width: fit-content;
                  padding: 4px 8px;
                  border-radius: 24px;
                  background: #f7f7f7;
                  font-size: 0.8rem;
                  color: #0096c7;
                  margin-bottom: 8px;
                }

                .headerTitle {
                  font-family: "iranyekanB", sans-serif;
                  font-size: 1rem;
                  color: #000;
                }

                .headerContent {
                  font-size: 0.9rem;
                  text-align: justify;
                  line-height: 28px;
                  color: #000;
                }
              }

              .mainOptions {
                width: 100%;
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                padding: 12px 0;

                .optionsList {
                  display: flex;
                  align-items: flex-start;

                  .optionThumb {
                    width: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    flex-direction: column;
                    color: #000;
                    gap: 8px;
                    cursor: pointer;

                    &.liked {
                      color: #f00;

                      .thumbNum {
                        color: #000;
                      }
                    }

                    svg {
                      width: 28px;
                      height: 28px;
                      flex-shrink: 0;
                    }

                    .thumbNum {
                      font-size: 0.95rem;
                      line-height: 1.25rem;
                    }
                  }
                }
              }

              .mainList {
                width: 100%;
                padding-top: 12px;

                .listThumb {
                  display: block;
                  .listThumbWrapper {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    margin-bottom: 16px;

                    .thumbPic {
                      width: 42px;
                      height: 42px;
                      flex-shrink: 0 !important;

                      img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                      }
                    }

                    .thumbContent {
                      flex-grow: 1 !important;
                      padding: 0 !important;
                      .contentDesc {
                        font-size: 0.875rem;
                        color: rgb(55 65 81);
                        line-height: 24px;

                        .userTitle {
                          font-family: "iranyekanB", sans-serif;
                          margin-left: 2px;
                          color: #000;
                        }
                      }

                      .contentDetails {
                        margin-top: 4px;
                        display: flex;
                        align-items: center;
                        gap: 16px;
                        color: rgb(107 114 128);
                        font-size: 0.75rem;

                        .detailsReply {
                          cursor: pointer;
                          transition: all 0.2s;

                          &:hover {
                            color: #0096c7;
                            transform: scale(1.05);
                          }
                        }
                      }
                    }
                  }

                  .thumbReplyList {
                    padding-right: 42px;

                    .listThumb {
                      .listThumbWrapper {
                        .thumbPic {
                          width: 32px;
                          height: 32px;
                        }

                        .thumbContent {
                          .contentDesc {
                            font-size: 0.75rem;
                          }
                          .contentDetails {
                            font-size: 0.675rem;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            .contentFooter {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              background: #fff;
              padding: 8px 16px;
              border-bottom-left-radius: 8px !important;
              border-top: 1px solid rgb(229 231 235);

              .footerFooter {
                .footerGroup {
                  position: relative;
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  .groupButton {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    flex-shrink: 0;
                    cursor: pointer;

                    svg {
                      width: 24px;
                      height: 24px;
                      fill: #0096c7;
                    }
                  }

                  .groupInput {
                    flex-grow: 1;
                    padding: 12px;
                    padding-right: 0;
                    font-size: 0.9rem;
                    background: transparent;
                  }

                  .cancleReply {
                    flex-shrink: 0;
                    padding: 4px 8px;
                    background: #c2e1ea;
                    color: #0096c7;
                    border-radius: 9999px;
                    cursor: pointer;
                    font-size: 0.75rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.no-result {
  text-align: center;
  margin-top: 32px;
}

@media (max-width: 700px) {
  .profileBuilder {
    .profileBuilderMain {
      padding-bottom: 98px;
      .mainContainer {
        .containerList {
          grid-template-columns: 100%;
          gap: 24px;

          .listThumb {
            .thumbContent {
              padding: 16px;

              .contentTitle {
                font-size: 1rem;
              }
              .contentDesc {
                font-size: 0.8rem;
                margin-bottom: 10px;
                height: auto;
              }
            }
          }
        }
      }
    }
  }
}

.apartmentsLoadMoreDataButton {
  width: 100%;
  margin: 36px;
}
.apartmentsLoadMoreDataButton .loadButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  text-align: center;
  background: #2dc653;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.9rem;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}

.loader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.fs-14 {
  font-size: 14px;
}
.role-label {
  background: rgb(223, 233, 244);
  margin-top: 6px;
  padding: 10px 36px;
  border-radius: 24px;
  color: rgba(40, 107, 184);
  margin-top: 16px;

  &.comments {
    background: #0096c7;
    color: #fff;
    margin-right: 12px;
    cursor: pointer;

    &.mobile {
      display: none;
    }

    &.desktop {
      display: block;
    }
  }
}

.loginMessage {
  font-size: 0.9rem;
}

@media (max-width: 600px) {
  .role-label {
    &.comments {
      &.mobile {
        display: block;
      }

      &.desktop {
        display: none;
      }
    }
  }
}

.comments-modal {
  height: 80vh;
}

.sendCommentBtn {
  width: 32px;
  height: 32px;
  background: transparent;
  font-size: 20px;
  color: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.commentsList {
  width: 96%;
  margin: 0 auto;
  padding: 24px 0;

  .commentInputWrapper {
    display: flex;
    margin-bottom: 24px;

    .inputUserProfile {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #000;
      margin-left: 16px;
    }

    &.newCommentInput {
      padding-bottom: 24px;
      border-bottom: 1px solid #eee;

      .commentInput {
        .addCommentInput {
          input {
            border: 1px solid #ddd;
            padding: 12px 8px;
            border-radius: 6px;
            font-size: 1rem;
            background: transparent;

            &:focus {
              border: 1px solid #0096c7;
            }
          }

          &::after {
            display: none;
          }
        }
      }
    }

    .commentInput {
      flex: 1;

      .addCommentInput {
        position: relative;
        margin-bottom: 8px;
        input {
          display: block;
          width: 100%;
          padding: 2px 0;
          border-bottom: 1px solid #ccc;
          background: transparent;
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          display: block;
          width: 100%;
          height: 1.5px;
          background: #0096c7;
          transform: scaleX(0);
          transition: all 0.2s;
        }

        &.focus {
          &::after {
            transform: scaleX(1);
          }
        }
      }

      .commentInputBtns {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .commentBtn,
        .cancleBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 76px;
          height: 36px;
          padding: 0 16px;
          font-size: 14px;
          line-height: 36px;
          border-radius: 18px;
          background: #0096c7;
          color: #fff;
          margin-right: 6px;
          cursor: pointer;

          .loader {
            margin: 0 !important;
          }
        }

        .cancleBtn {
          background: #e5f0ff;
          color: #0096c7;
        }

        .commentBtn.disabled {
          pointer-events: none;
          cursor: none;
          opacity: 0.4;
        }
      }
    }
  }

  .commentThumb {
    display: flex;
    margin-bottom: 16px;

    .commentProfile {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #0096c7;
      flex-shrink: 0;
      margin-left: 16px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .commentContent {
      flex: 1;

      .commentHeader {
        display: flex;
        align-items: center;
        gap: 8px;
        .userName {
          font-family: "iranyekanB", sans-serif;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 2px;
        }

        .commentDate {
          font-family: "iranyekan", sans-serif;
          font-size: 12px;
          color: #999;
        }
      }

      .commentText {
        font-family: "iranyekan", sans-serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.25rem;
        margin-bottom: 2px;
      }

      .commentBtns {
        display: flex;
        margin-bottom: 4px;

        .commentLikesBtn {
          display: flex;

          .likeBtnWrapper {
            display: flex;

            .likeNum {
              margin-left: 8px;
              margin-right: 2px;
              padding-top: 4px;
              font-size: 14px;
            }
          }

          .likeBtn,
          .disLikeBtn {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            svg.commentBtnIcon {
              font-size: 14px;
              stroke: #0096c7 !important;
              path {
                stroke: #0096c7 !important;
              }
            }

            &:hover {
              background: #e5f0ff;
            }
          }
        }

        .commentReplyBtn {
          margin-right: 8px;
          margin-top: 6px;
          padding: 0 8px;
          font-size: 13px;
          line-height: 24px;
          border-radius: 16px;
          cursor: pointer;
          background: #e5f0ff;
          color: #0096c7;
        }
      }

      .commentInputWrapper {
        display: none;

        &.show {
          display: flex;
        }
        padding-right: 4px;
        margin-bottom: 2px;
        .inputUserProfile {
          width: 24px;
          height: 24px;
        }
      }

      .commentsReplyToggler {
        .commentsReplyToggleBtn {
          padding: 0 16px;
          width: fit-content;
          height: 36px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          border-radius: 16px;
          color: #0096c7;
          cursor: pointer;

          &:hover {
            background: #e5f0ff;
          }
        }
      }

      .commentsReply {
        display: none;

        &.show {
          display: block;
        }
        .commentThumb {
          width: 100%;
          .commentProfile {
            width: 24px;
            height: 24px;
            margin-right: 16px;
            margin-top: 8px;
          }
        }
      }
    }
  }
}

.commentsDestopBody {
  width: 100%;
}

.roleContainer {
  display: flex;
  align-items: center;
}

.dark {
  .ShowCommandBoxesMyBottomSheet {
    .dentMessageToCommentWrapper {
      background: #101a23;

      .commentRatingComp {
        color: #fff;
      }
    }
  }
  .changePostBtn {
    background: #101a23 !important;
    color: #fff !important;
    box-shadow: 0 0 6px rgba(255, 255, 255, 0.25);
  }
  .detailsContainer {
    .containerList {
      background: #101a23 !important;

      .listThumb {
        .thumbPic {
          background: #1e262f !important;
        }
        .thumbContent {
          .contentHeader {
            background: #101a23 !important;
            border-bottom: 1px solid rgb(53, 53, 54) !important;

            .headerContent {
              .contentInfo {
                color: #fff !important;
              }
            }

            .headerOptions {
              .optionUnFollow {
                background: #101a23 !important;
              }
            }
          }

          .contentMain {
            .mianHeader {
              border-bottom: 1px solid rgb(53, 53, 54) !important;
              .headerTitle,
              .headerContent {
                color: #fff !important;
              }
            }

            .mainOptions {
              .optionsList {
                .optionThumb {
                  &:not(.liked) {
                    color: #fff !important;
                  }

                  .thumbNum {
                    color: #fff !important;
                  }
                }
              }
            }
          }

          .contentFooter {
            background: #101a23 !important;
            border-top: 1px solid rgb(53, 53, 54) !important;

            .footerFooter {
              .footerGroup {
                .groupInput {
                  color: #fff !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
.whiteLoader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.propertyEditsButtons {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;

  .propertyBtn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1),
      0 4px 6px -4px rgb(0 0 0 / 0.1);
    color: #fff;
    cursor: pointer;

    i {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    &.editBtn {
      background: #0096c7;
    }

    &.deleteBtn {
      background: rgb(239 68 68);
    }
  }
}

.ShowCommandBoxesMyBottomSheet {
  height: 500px;
  overflow-y: hidden;

  .dentMessageToCommentSpace {
    height: 60px;
  }

  .dentMessageToCommentWrapper {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 10px;
    padding-top: 6px;
    border-top: 1px solid #ededed;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
    background: #fff;

    .commentRatingComp {
      display: flex;
      gap: 6px;
      align-items: center;
      margin-bottom: 4;

      span {
        display: inline-block;
        margin-top: 6px;
        font-size: 0.85rem;
      }

      .el-rate {
        .el-rate__item {
          .el-icon {
            svg {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }

  .dentMessageToComment {
    height: 60px;
    display: flex;
    gap: 10px;
    align-items: center;
    .mobileNewCommentInput {
      width: 100%;
      height: 40px;
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border-radius: 5px;
      input {
        background: transparent;
        height: 100%;
        padding: 0 10px;
        font-size: 1rem;
      }
    }

    .cancleReply {
      position: absolute;
      left: 22px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      padding: 6px 8px;
      border: 1px solid #0096c7;
      background: #e5f0ff;
      color: #0096c7;
      border-radius: 24px;
    }
  }

  .dentMessageToComment {
    height: 60px;
    display: flex;
    gap: 12px;
    align-items: center;

    .sendCommentBtnWrapper {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0096c7;
      border-radius: 12px;
      flex-shrink: 0;

      .sendCommentBtn {
        color: #fff !important;
      }

      span.loader {
        margin: 0 !important;
      }
    }

    .mobileNewCommentInput {
      width: 100%;
      height: 40px;
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border-radius: 12px;
      input {
        background: transparent;
        height: 100%;
        padding: 0 10px;
        font-size: 1rem;
      }
    }

    .cancleReply {
      position: absolute;
      left: 22px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      padding: 6px 8px;
      border: 1px solid #0096c7;
      background: #e5f0ff;
      color: #0096c7;
      border-radius: 24px;
    }
  }

  .AllChildCommentRefSheet {
    margin: auto;
    width: 95%;
    padding: 10px;
    position: relative;
  }

  .ChildCommentRefSheetVg {
    display: flex;
    align-items: center;
    justify-content: space-between;
    svg {
      cursor: pointer;
    }
  }

  .ChildCommentRefSheet {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    height: 50px;

    .TitleChildCommentRefSheetTitle {
      display: flex;
      flex-direction: column;

      .el-rate__item {
        width: 18px !important;
        height: 16px !important;
      }

      .el-icon.el-rate__icon {
        width: 14px !important;
        height: 14px !important;
        margin: 0 !important;
      }
    }
  }

  .ReplayChildCommentRefSheet {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 50px;
    margin-top: 20px;
    .TitleChildCommentRefSheet {
      border-radius: 10px;

      h1 {
        font-size: 0.85rem;
      }

      p {
        font-size: 0.8rem;
        color: #333;
      }
    }

    .ImageChildCommentRefSheet {
      height: 30px;
      width: 30px;
      border-radius: 100%;
      overflow: hidden;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .ImageChildCommentRefSheet {
    height: 34px;
    width: 34px;
    border-radius: 100%;
    overflow: hidden;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .TitleChildCommentRefSheet {
    h1 {
      font-size: 0.9rem;
      font-weight: 500;
      color: rgb(21, 21, 77);
      font-family: "iranyekanB";
    }

    p {
      font-size: 0.75rem;
      color: #555;
      font-family: "iranyekan";
    }
  }
}

.noComments {
  font-size: 1.15rem;
  padding: 68px 0 54px;
  text-align: center;
}

.mobileNocomments {
  padding: 48px 0;
  font-size: 1rem;
  color: #777;
  text-align: center;
}

.followUnfollowBtns {
  margin-top: 16px;

  .followBtn,
  .unfollowBtn {
    width: 312px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    border: 1px solid #0096c7;
    border-radius: 8px;
    cursor: pointer;
  }

  .followBtn {
    background: #0096c7;
    color: #fff;
  }

  .unfollowBtn {
    background: transparent;
    color: #0096c7;
  }
}

@media (max-width: 700px) {
  .followUnfollowBtns {
    .followBtn,
    .unfollowBtn {
      width: 212px;
      height: 38px;
    }
  }
}

.skeleton-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
}

.TopShowToUSerNAme {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
}

.ImageTopShowToUSerNAme {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0f0f0;
  margin-right: 10px;
}

.titleTopShowToUSerNAme {
  width: 150px;
  height: 30px;
  background: #f0f0f0;
  border-radius: 4px;
}

.skeleton-image {
  width: 100%;
  height: 200px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-bottom: 15px;
}

.skeleton-text {
  width: 100%;
  height: 15px;
  background: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-text.short {
  width: 60%;
}

.postCommentloader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #0096c7;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.noResultThumb {
  padding: 42px 0;
  .noResultPic {
    img {
      max-width: 90%;
      height: 280px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .noResult {
    text-align: center;
    font-size: 0.95rem;
  }
}

.dark {
  .noResultThumb {
    .noResult {
      color: #fff;
    }
  }
}

.ChildShowInputFormToUser {
  label {
    span {
      color: #f00;
    }
  }
}

.editMapContainer {
  .containerLabel {
    span {
      color: #f00;
    }
  }
}
.addPic_text {
  span {
    color: #f00;
  }
}

.activityOptionsList {
  width: 90%;
  margin-top: 6px;
  margin-left: auto;
  margin-right: auto;
  .listWrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px 12px;

    .listThumb {
      display: flex;
      align-items: center;
      gap: 8px;

      label {
        margin: 0 !important;
      }

      .hiddenInput {
        display: none;
      }

      .filterListInput {
        cursor: pointer;
        .customCheckBox {
          position: relative;
          width: 20px;
          height: 20px;
          border: 1px solid #474747;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 2px;
          flex-shrink: 0;

          &.checked {
            border: 1px solid #0096c7;

            .checkedTick {
              opacity: 1;
            }
          }

          input {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
            z-index: 2;
            opacity: 0;
          }

          .checkedTick {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            background: #0096c7;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 0.75rem;
            opacity: 0;
          }
        }
      }

      .filterListTitle {
        font-size: 0.75rem;
        cursor: pointer;
        display: flex;
        align-items: flex-start;
        gap: 4px;
        font-weight: 200;

        span {
          font-size: 0.9rem;
          display: block;
          height: 0;
        }
      }
    }
  }
}

.ShowInputFormToUser1 {
  .ChildShowInputFormToUser {
    textarea {
      line-height: 22px;
      height: 92px !important;
    }
  }
}

@media (max-width: 700px) {
  .profileHeader {
    padding: 24px 0 16px;
    margin-bottom: 0;

    .headerContainer {
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .containerHeader {
        margin-bottom: 16px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: row-reverse;
        gap: 16px;

        .headerDetails {
          flex-grow: 1;
          display: block;
          .deatislTitle {
            display: flex;
            align-items: center;
            gap: 8px;

            .titleSk {
              width: 192px;
              height: 36px;
              border-radius: 9999px;
            }

            span {
              font-family: "iranyekanB", sans-serif;
              font-size: 1.35rem;
              line-height: 2rem;
              margin-bottom: 4px;
              color: rgb(31 41 55);
            }
          }
          .detailsBrand {
            color: rgb(75 85 99);
            margin-bottom: 4px;
            font-size: 0.915rem;
            line-height: 1.25rem;

            .brandSk {
              width: 142px;
              height: 20px;
              border-radius: 9999px;
            }
          }

          .detailsRole {
            color: rgb(107 114 128);
            margin-bottom: 4px;
            font-size: 0.9rem;
            line-height: 1.25rem;

            .roleSk {
              width: 124px;
              height: 20px;
              border-radius: 9999px;
            }
          }

          .detailsRate {
            display: flex;
            align-items: center;
            gap: 4px;

            & > div {
              font-size: 0.875rem;
              color: rgb(107 114 128);
              line-height: 1.25rem;

              span {
                font-size: 1.125rem;
                line-height: 1.75rem;
                color: rgb(31 41 55);
                font-weight: 600;
              }
            }

            i {
              color: rgb(250 204 21);
            }
          }
        }
        .headerProfile {
          flex-shrink: 0;
          /* padding-left: 24px; */

          .profilePic {
            width: 94px;
            height: 94px;
            border-radius: 50%;
            padding: 3px;
            background: linear-gradient(
              45deg,
              #feda75,
              #fa7e1e,
              #d62976,
              #962fbf,
              #4f5bd5
            );
            display: flex;
            align-items: center;
            justify-content: center;

            .profileSk {
              width: 100%;
              height: 100%;
              border-radius: 9998px;
            }

            &.noStory {
              background: transparent;
            }

            img {
              width: 90px;
              height: 90px;
              border-radius: 9999px;
              object-fit: cover;
              object-position: center;
            }
          }
        }
      }

      .containerMain {
        .mainStatistics {
          margin-bottom: 24px;

          .statisticsWrapper {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 1rem;

            .statisticsThumb {
              text-align: center;

              .thumbSk {
                width: 58px;
                height: 58px;
                margin-left: auto;
                margin-right: auto;
                border-radius: 8px;
              }

              .thumbValue {
                font-size: 1.5rem;
                line-height: 2rem;
                font-family: "iranyekanB", sans-serif;
                color: rgb(31 41 55);
              }
              .thumbTitle {
                font-size: 0.875rem;
                line-height: 1.25rem;
                color: rgb(107 114 128);
              }
            }
          }
        }
        .mainOptions {
          position: static;
          width: 100%;
          margin-bottom: 24px;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 0.75rem;

          &.userCustomer {
            grid-template-columns: 100%;
          }

          .thumbSk {
            width: 100%;
            height: 46px;
            border-radius: 12px;
          }

          .optionsThumb {
            width: 100%;
            height: 46px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #fff;
            border-radius: 12px;
            font-size: 1rem;
            gap: 8px;

            &.followBtn {
              background: #0096c7;
              color: #fff;
              border-color: #0096c7;
            }

            &.unfollowBtn {
              background: #ef4444;
              color: #fff;
              border-color: #ef4444;
            }

            &.rateThumb {
              border-color: #ff7b00;
              background: #ff7b00;
            }
          }
        }
      }
      .containerFooter {
        display: block;

        .footerSk {
          width: 100%;
          height: 18px;
          border-radius: 9999px;
          margin-bottom: 6px;
        }

        .footerSection {
          &:not(:last-child) {
            margin-bottom: 16px;
          }

          .sectionHeader {
            color: rgb(31 41 55);
            font-weight: 600;
            font-size: 0.875rem;
            line-height: 1.25rem;
            margin-bottom: 8px;
          }

          &.bioSection {
            .sectionMain {
              line-height: 1.625;
              color: rgb(55 65 81);
              font-size: 0.875rem;
            }
          }

          &.contactSection {
            .sectionMain {
              .contactThumb {
                display: flex;
                align-items: center;
                gap: 8px;
                color: rgb(75 85 99);
                font-size: 0.875rem;
                line-height: 1.25rem;
                &:not(:first-child) {
                  margin-top: 8px;
                }
              }
            }
          }

          &.mediaSection {
            .sectionMain {
              display: flex;
              align-items: center;
              gap: 16px;

              .mediaThumb {
                color: rgb(75 85 99);
                font-size: 1.5rem;
                line-height: 1.75rem;

                &.telegram {
                  color: #0088cc;
                }

                &.instagram {
                  background: linear-gradient(
                    45deg,
                    #feda75,
                    #fa7e1e,
                    #d62976,
                    #962fbf,
                    #4f5bd5
                  );
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }

                &.whatsapp {
                  color: #25d366;
                }
              }
            }
          }
        }
      }
    }
  }
  .ShowInputFormToUser1 {
    &.profileEditForm {
      display: block;
    }
  }

  .resProfileEditBtn {
    font-size: 0.95rem;
  }
}

@media (min-width: 500px) {
  .ChildShowInputFormToUser {
    &.activityType {
      grid-column: span 2;
    }
  }
}

.map {
  width: 100%;
  height: 100%;
}

.followLoader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

/* Loading indicator برای lazy loading */
.lazy-loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 10px 0;

  .loading-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #0096c7;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }

  p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
